import { Subscription, Observable, Subject, of, timer } from 'rxjs';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Inject, Optional, NgZone, HostListener } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { allowedBillFiles, allowedBillGPayFiles, allowedBillQRFiles, allowedFiles, appt_type_images, convertToNgbDate, datePickerMinDate, isImage, isSCCase, reported_as_list, triageList, } from '../../shared/constants';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry } from 'ngx-file-drop';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addDays, isBefore } from 'date-fns';
import { NavbarComponent } from '../../navbar/navbar.component';
import { FollowupDetailsComponent } from '../followup-details/followup-details.component';
import VirtualBackgroundExtension from "agora-extension-virtual-background";
import { Howl } from 'howler';
import { IAgoraRTCRemoteUser, IAgoraRTCClient, ICameraVideoTrack, IMicrophoneAudioTrack, ILocalVideoTrack, AREAS, ILocalTrack } from "agora-rtc-sdk-ng";
import AgoraRTC from "agora-rtc-sdk-ng";
import { AgoraRtmService } from '../../agora-rtm.service';
import { Timestamp, Firestore, collection, collectionData, query, where, orderBy, doc, getDocs, updateDoc, deleteDoc, onSnapshot, limit, startAfter, QuerySnapshot, DocumentData, writeBatch, arrayUnion } from '@angular/fire/firestore';
import { MessagingService } from '../../messaging.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { FileUploadComponent } from '../../shared/file-upload/file-upload.component';
declare var $: any;

@Component({
	selector: 'app-case-details',
	templateUrl: './case-details.component.html',
	styleUrl: './case-details.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})

export class CaseDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}
	uId: any = null;
	caseDetails: any = {};
	subsymptoms: any = [];
	followupList: any[] = [];
	loadingFollowUp = true;
	File_Storage_URL = environment.File_Storage_URL;
	production = environment.production;
	sign_off_by_model: any = null;
	triageCode: any = null;
	triageList = triageList;
	updateLoader = false;
	minDate = datePickerMinDate;
	activeTab: any = 1;
	showDeleteLoader: any = null;
	followUpBillsData: any[] = [];
	loadingBilling = false;
	moduleForm: FormGroup = this.formBuilder.group({
		closure_notes: [null, [Validators.required]],
		status4_id: [null, [Validators.required]]
	});
	showLoader = false;
	formSubmitted = false;
	get f() { return this.moduleForm.controls }
	fitnessStatusList: any[] = [];
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
			]
		}
	};
	case_category_id: any = null;
	work_related = false;
	allCaseCategories: any[] = [];
	tblCollapseHeightCaseDetails = "250px";
	tblCollapseHeight = "";
	assigned_sc_agent_id: any = null;
	doctorList: any[] = [];
	mark_for_closure = false;
	mark_loader = false;
	closure_report_sent = false;
	rep_sent_loader = false;
	hospStatusList: any = [];
	surgeryStatusList: any = [];
	/* disablityStatusList: any = []; */
	status3List: any[] = [];
	status4List: any[] = [];
	followUpStatusList: any = [];
	searchControl = new FormControl(null);
	formCtrlSub!: Subscription;
	fetchCaseIdDetailsLoader = false;
	detailsFromCaseId: any = null;
	loadingReminders = false;
	caseReminder: any = null;
	loadingFeedback = false;
	saveFeedbackLoader = false;
	feedbackQuestions: any[] = [];
	rankList: any[] = [];
	countryList: any[] = [];
	companyList: any[] = [];

	amount = 0;

	billingDetailsForEdit: any[] = [];
	saveBillLoader = false;
	billFileUploadLoader: any = null;
	billCategoryList: any[] = [];
	billingMaxDate = convertToNgbDate(new Date());
	appt_type_images = appt_type_images;

	loadingHandover = false;
	nonMedicalList: any[] = [];
	isSCCase = isSCCase;

	ready_to_bill = false;
	candidate_no_dues = 0;
	vendor_no_dues = 0;
	ready_to_bill_loader = false;

	newFollowupForm: FormGroup = this.formBuilder.group({
		new_follow_up_date: [null, [Validators.required]],
		new_visit_type_id: [null, [Validators.required]]
	});
	get f2() { return this.newFollowupForm.controls }
	flwupFormSubmitted = false;
	newFollowupLoader = false;
	customErrorNewFlwup: any = {};
	allVisitType: any = [];
	selectedFollowUpId: any = null;
	@ViewChild("followupDetailsComponent") followupDetailsComponent!: FollowupDetailsComponent;
	@ViewChild(RouterOutlet) mail_outlet!: RouterOutlet;

	remoteCalls: any[] = [];
	localStreams: any = [];
	currentVideo: any = null;

	videoClient: IAgoraRTCClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'h264' });
	videoClientForOnlineCheck: IAgoraRTCClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'h264' });
	screenClient!: IAgoraRTCClient;
	localVideoStream!: ICameraVideoTrack;
	localAudioStream!: IMicrophoneAudioTrack;
	shareStream!: ILocalVideoTrack;

	channelName: any = null;
	userId!: number;
	/* screenUserId!: number; */
	/* otherSideUserId!: number;
	otherSideScreenUserId!: number; */
	userName: string = "";
	candidateUserName: string = "";
	joinStatus = { isJoined: false };
	isMute = false;
	isVideoMute = false;
	agoraAppId = environment.agoraAppID;
	cameraVideoProfile = '480_4';
	screenVideoProfile = '480_2';
	msg: any = null;
	messages: any[] = [];
	allMessages: any[] = [];
	/* peers: string[] = [];
	private subs: Subscription[] = []; */
	numbers = [
		{ num: 1, color: "#28a745" },
		{ num: 2, color: "#28a745" },
		{ num: 3, color: "#007bff" },
		{ num: 4, color: "#007bff" },
		{ num: 5, color: "#ffc107" },
		{ num: 6, color: "#ffc107" },
		{ num: 7, color: "#ff5707" },
		{ num: 8, color: "#ff5707" },
		{ num: 9, color: "#dc3545" },
		{ num: 10, color: "#dc3545" }
	];
	numberOfPidsToColor: number = 0;
	intervalMicListen: any = null;
	playAlertRing = new Howl({
		src: ['../../../assets/files/sound1.mp3']
	});
	playAlertNotify = new Howl({
		src: ['../../../assets/files/sound2.mp3']
	});
	playRingSound = new Howl({
		src: ['../../../assets/files/outgoing-ring.mp3'],
		loop: true
	});
	audioDevices: any[] = [];
	videoDevices: any[] = [];
	selectedMicrophoneId: any = null;
	selectedCameraId: any = null;
	doctor_avatar = "../../../assets/img/PSYCHOLOGIST.png";
	/* remoteUsers: any[] = []; */
	videoHeightLocal = 75;
	videoWidthLocal = 100;
	videoHeightRemote = 150;
	videoWidthRemote = 200;
	mainVideoHeight: number = window.innerHeight - 130;
	extension = new VirtualBackgroundExtension();
	processor: any = null;
	virtualBackgroundEnabled: string = "";
	backgroundProp: string = "#00ff00";
	bgColors = [
		"#00008B",
		"#808080",
		"#FBFAF5",
		"#475c6c",
		"#eed7a1",
		"#f7efd2"
	];
	bgImages = [
		"../../../assets/img/bg1.jpeg",
		"../../../assets/img/bg2.jpg",
		"../../../assets/img/bg3.jpg",
		"../../../assets/img/bg4.jpg",
		"../../../assets/img/bg5.jpg",
		"../../../assets/img/bg6.jpg"
	];
	followId: any = null;
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	pageLoading1 = false;
	user: any = null;
	/* private messagesSub!: Subscription; */
	chatCollectionName = "chat";
	callCollectionName = "call";
	chatAction: any = null;
	unreadCount$!: Observable<number>;
	isHover = false;
	msgSearchControl = new FormControl("");
	msgFormCtrlSub!: Subscription;
	/* @ViewChildren(CdkVirtualScrollViewport) viewports!: QueryList<CdkVirtualScrollViewport>; */
	@ViewChild('mat_expansion_panel') mat_expansion_panel!: MatExpansionPanel;
	private destroy$ = new Subject<void>();

	constructor(private messagingService: MessagingService, private firestore: Firestore, /* private chatService: ChatService, */ private agora: AgoraRtmService, private zone: NgZone, private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.apiService.getFollowUpFilesRefreshEvent().subscribe({
			next: (val) => {
				if (val) {
					this.getCaseDetails();
				}
			}
		});
		this.apiService.mailSelectEvent$.subscribe({
			next: (val) => {
				if (val) {
					this.setActiveTab(5);
				}
			}
		});
		this.apiService.doctorData$.subscribe((doctors: any) => {
			if (doctors) {
				this.getAllDoctors();
			}
		});
	}

	ngOnInit(): void {
		/* this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"];
			this.selectedFollowUpId = routeParams["folUpId"] == "empty" ? null : routeParams["folUpId"];
			this.getCaseDetails();
			this.getFollowup();
			this.getFitnesStatus();
			this.getCaseCatList();
			this.getAllDoctors();
			this.getAllFollowUpStatus();
			this.getRank();
			this.getCountryList();
			this.getCompany();
			this.getBillCategoryList();
			this.allVisitTypeApi();
		}); */
		this.apiService.userData$.subscribe((user: any) => {
			if (user) {
				this.activeRoute.paramMap.pipe(
					map(params => ({
						uId: params.get('uId'),
						chatAction: params.get('chatAction')
					})),
					distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
					tap(({ uId, chatAction }) => {
						this.chatAction = chatAction;
						let uIdParam = uId;
						/* if (uIdParam) {
							if (uIdParam.includes("init_v_")) {
								uIdParam = uIdParam.replace("init_v_", "");
								this.initCandConnType = "video";
							} else if (uIdParam.includes("init_a_")) {
								uIdParam = uIdParam.replace("init_a_", "");
								this.initCandConnType = "audio";
							} else if (uIdParam.includes("init_c_")) {
								uIdParam = uIdParam.replace("init_c_", "");
								this.initCandConnType = "chat";
							}
						} */
						this.uId = uIdParam;
						try {
							this.uId = decodeURIComponent(this.uId);
						} catch (e) { }
						this.user = user;
						this.getCaseDetails();
						this.getFollowup();
						this.getFitnesStatus();
						this.getCaseCatList();
						/* this.getAllDoctors(); */
						this.getAllFollowUpStatus();
						this.getRank();
						this.getCountryList();
						this.getCompany();
						this.getBillCategoryList();
						this.allVisitTypeApi();
						this.getUsers();
					})
				).subscribe();
			}
		});
	}

	ngAfterViewInit(): void {
		this.formCtrlSub = this.searchControl.valueChanges.pipe(debounceTime(1000)).subscribe(newValue => {
			this.getHCCaseDetails();
		});
		this.apiService.attachmentData$.subscribe((data) => {
			if (data && data.attachments && data.attachments.length) {
				this.selectedMailId = data.mailId;
				this.selectedAttType = data.type;
				this.selectedAttachments = JSON.parse(JSON.stringify(data.attachments.filter((att: any) => att.selected)));
				if (this.selectedAttType == "bill") {
					this.openBillModal();
				} else {
					this.openFileModal();
				}
			}
		});
		this.activeRoute.paramMap.pipe(
			map(p => p.get('folUpId')),
			distinctUntilChanged(),
			tap(folUpId => {
				this.selectedFollowUpId = folUpId == "empty" ? null : folUpId;
				try {
					if (this.selectedFollowUpId) {
						this.selectedFollowUpId = decodeURIComponent(this.selectedFollowUpId);
					}
				} catch (e) { }
				if (this.selectedFollowUpId) {
					this.selectFollowUp(this.selectedFollowUpId);
				}
			})
		).subscribe();
		/* this.closeForm(); */
		this.msgFormCtrlSub = this.msgSearchControl.valueChanges.pipe(debounceTime(500)).subscribe(newValue => {
			this.applyChatSearch();
		});
		/* this.apiService.viewportData1$.subscribe((data) => {
			try {
				const viewport = this.viewports.find(v =>
					v.elementRef.nativeElement.dataset.id === 'chatscroll'
				);
				if (!viewport) {
					return;
				}
				viewport.checkViewportSize();
			} catch (error) { }
		}) */
	}

	ngOnDestroy(): void {
		try {
			this.formCtrlSub.unsubscribe();
		} catch (error) { }
		try {
			this.msgFormCtrlSub.unsubscribe();
		} catch (error) { }
		try {
			this.clearBackground();
		} catch (error) { }
		if (this.joinStatus.isJoined == true) {
			try {
				this.beforeSendNotification(4);
				this.leave();
			} catch (error) { }
		} else {
			try {
				this.stopTestCamera();
			} catch (error) { }
		}
		/* try {
			this.chatService.logout();
		} catch (error) { } */
		/* try {
			this.messagesSub.unsubscribe();
		} catch (error) { } */
		try {
			this.destroy$.next();
			this.destroy$.complete();
		} catch (error) { }
	}

	mediaRecorder!: MediaRecorder;
	stream!: MediaStream;
	audioChunks: Blob[] = [];
	isRecording = false;
	audioFileUploadLoader = false;
	async startRecording() {
		if (this.isRecording) return;
		this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
		this.mediaRecorder = new MediaRecorder(this.stream);
		this.audioChunks = [];
		this.mediaRecorder.ondataavailable = event => {
			this.audioChunks.push(event.data);
		};
		this.mediaRecorder.start();
		this.isRecording = true;
	}

	stopRecording() {
		if (!this.isRecording) return;
		this.mediaRecorder.stop();
		this.isRecording = false;
		this.stream.getTracks().forEach(track => track.stop());
		this.mediaRecorder.onstop = () => {
			const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
			const audioFile = new File(
				[audioBlob],
				'voice-note.webm',
				{ type: audioBlob.type }
			);
			const formData = new FormData();
			formData.append("type", 'chat_files/' + this.caseDetails?.id);
			formData.append("flag", "true");
			formData.append('file', audioFile);
			this.audioFileUploadLoader = true;
			this.apiService.uploadFile(formData).subscribe({
				next: (data: any) => {
					this.audioFileUploadLoader = false;
					this.toastr.success("File uploaded successfully.", 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					this.sendFile(data);
				}, error: (error: any) => {
					this.audioFileUploadLoader = false;
					if (error.status == 401) { return }
					this.toastr.error("Something went wrong", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
		};
	}

	users: any[] = [];
	getUsers() {
		this.apiService.getUserDetails({}).subscribe({
			next: (data: any) => {
				this.users = data.data;
			}, error: (error) => {
				this.users = [];
			}
		});
	}

	getUserNameByChatUsername(username: string) {
		try {
			if (username.includes("doc_")) {
				let userId = parseInt(username.replace("doc_", ""));
				let user = this.users.find((u) => u.user.id == userId);
				if (user) {
					return `${user.user.first_name} ${user.user.last_name}`;
				}
			} else if (username.includes("candidate_")) {
				return this.getCandidateName();
			}
		} catch (error) { }
		return username;
	}

	getCandidateName() {
		return `${this.caseDetails?.f_name} ${this.caseDetails?.l_name}`;
	}

	copyLoader: any = null;
	attDest: any = null;
	selectedMailId: any = null;
	selectedAttType: any = null;
	selectedAttachments: any[] = [];
	addMailAttachments(index: number, dest: string) {
		this.attDest = dest;
		let type: string = "";
		if (dest == "bill_file" || dest == "gpay") {
			type = "follow_up_bills";
		} else if (dest == "file") {
			type = "follow_up_files";
		}
		const files = this.selectedAttachments.map((att: any) => new URL(att.url).pathname.slice(1));
		const payload = { files: files, type: type };
		this.copyLoader = index;
		this.apiService.copyMailFilesToBilling(payload).subscribe({
			next: (data: any) => {
				if (dest == "bill_file") {
					if (!this.billingDetailsForEdit[index].files) {
						this.billingDetailsForEdit[index].files = [];
					}
					for (let i = 0; i < data.length; i++) {
						this.billingDetailsForEdit[index].files.push(data[i]);
					}
				} else if (dest == "gpay") {
					if (!this.billingDetailsForEdit[index].gpay_files) {
						this.billingDetailsForEdit[index].gpay_files = [];
					}
					for (let i = 0; i < data.length; i++) {
						this.billingDetailsForEdit[index].gpay_files.push(data[i]);
					}
				} else if (dest == "file") {
					if (!this.followupFilesForEdit[index].file_url) {
						this.followupFilesForEdit[index].file_url = [];
					}
					for (let i = 0; i < data.length; i++) {
						this.followupFilesForEdit[index].file_url.push(data[i]);
					}
				}
				this.copyLoader = null;
				this.attDest = null;
				this.toastr.success('Files added successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.clearSelectedAttachments();
				/* this.updateMailAttachments(); */
			}, error: (error) => {
				this.copyLoader = null;
				this.attDest = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	clearSelectedAttachments() {
		this.selectedAttachments = [];
		this.selectedMailId = null;
		this.selectedAttType = null;
	}

	disableBillFileAtt(index: number) {
		return this.copyLoader == index && this.attDest == "bill_file";
	}

	disableBillGPayAtt(index: number) {
		return this.copyLoader == index && this.attDest == "gpay";
	}

	disableFileAtt(index: number) {
		return this.copyLoader == index && this.attDest == "file";
	}

	/* updateMailAttachments() {
		const att_payload = {
			id: this.selectedMailId,
			attachment: JSON.stringify(
				this.selectedAttachments.map((att: any) => {
					if (att.selected) {
						att.used_in_bill = true;
					}
					delete att.selected;
					return att;
				})
			)
		};
		this.apiService.updateMailAttachment(att_payload).subscribe({
			next: (data: any) => {
				this.apiService.setAttChangedData(att_payload);
				this.clearSelectedAttachments();
			}, error: (error) => {
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	} */

	getTabClass(tabNum: any) {
		if (this.activeTab == tabNum) {
			return "active";
		} else {
			return "";
		}
	};

	setActiveTab(tabNum: any) {
		this.activeTab = tabNum;
		if (tabNum == 0) {
			this.getQuestions();
		} else if (tabNum == 1) {
			/* this.getFollowup(); */
		} else if (tabNum == 2) {
			this.getFolloupBillsByCase();
		} else if (tabNum == 3) {
			this.getFeedback();
		} else if (tabNum == 4) {
			this.getHandover();
		} else if (tabNum == 5) {
			if (!this.mail_outlet || !this.mail_outlet.isActivated) {
				let url = this.router.url;
				try {
					url = decodeURIComponent(url);
				} catch (error) { }
				if (!url.includes("mails")) {
					this.router.navigate([url, 'mails']);
				}
			}
			setTimeout(() => {
				this.apiService.setViewportData(true);
			}, 100);
		} else if (tabNum == 6) {
		} else if (tabNum == 7) {
			this.getFilesFromCandidate();
		} else if (tabNum == 8) {
			this.getRecordings();
		} else if (tabNum == 9) {
			this.getAdminNotes();
		} else if (tabNum == 10) { }
	};

	getFollowUpUrl(fuId: string) {
		let url = this.router.url;
		try {
			url = decodeURIComponent(url);
		} catch (error) { }
		try {
			if (url.includes("/empty")) {
				url = url.replace("empty", fuId);
			} else {
				if (this.selectedFollowUpId) {
					url = url.replace(this.selectedFollowUpId, fuId);
				}
			}
		} catch (error) { }
		return url;
	}

	getTabPaneClass(tabNum: any) {
		if (this.activeTab == tabNum) {
			return "tab-pane active";
		} else {
			return "tab-pane";
		}
	}

	follFromReminder(follId: any) {
		this.setActiveTab(1);
		this.router.navigate([this.getFollowUpUrl(follId)]);
		this.mat_expansion_panel.close();
	}

	getCountryList() {
		this.apiService.countryList().subscribe({
			next: (data: any) => {
				this.countryList = data.data;
			}, error: (error) => {
				this.countryList = [];
			},
		});
	}

	getRank() {
		this.apiService.getRank({}).subscribe({
			next: (data: any) => {
				this.rankList = data.data;
			}, error: (error) => {
				this.rankList = [];
			},
		});
	}

	getCompany() {
		this.apiService.getCompany({}).subscribe({
			next: (data: any) => {
				this.companyList = data.data;
			}, error: (error) => {
				this.companyList = [];
			},
		});
	}

	validateForMarkForClosure() {
		let msgList: string[] = [];
		if (this.caseReminder?.crew_details_not_filled) {
			msgList.push("<li>Ensure all crew details are filled</li>");
		}
		if (this.caseReminder?.data_not_filled) {
			msgList.push("<li>Ensure key evaluations are filled</li>");
		}
		if (this.caseReminder?.files_not_uploaded.length) {
			msgList.push("<li>Upload all missing files under follow-ups</li>");
		}
		/* for (let i = 0; i < this.followupList.length; i++) {
			if (
				this.followupList[i].follow_up_status?.id == 1
			) {
				msgList.push("<li>Ensure all follow-ups are completed</li>");
				break;
			}
		} */
		let isAnyFollowupClosed = false;
		for (let i = 0; i < this.followupList.length; i++) {
			if (
				this.followupList[i].follow_up_status?.id == 3
			) {
				isAnyFollowupClosed = true;
				break;
			}
		}
		if (!isAnyFollowupClosed) {
			msgList.push("<li>Ensure all follow-ups are completed</li>");
		}
		return msgList;
	}

	markForClosureChange() {
		if (this.mark_for_closure) {
			let msgList = this.validateForMarkForClosure();
			if (msgList.length) {
				let str = '<p class="mb-0">To proceed and mark this case as <strong>"Marked for closure"</strong>, please ensure the following actions are completed';
				str += "<ol>"
				str += msgList.join("");
				str += "</ol>"
				Swal.fire({
					title: 'Incomplete details',
					html: str,
					icon: 'warning',
					customClass: { htmlContainer: "text-start" }
				});
				setTimeout(() => {
					this.mark_for_closure = false;
				}, 0);
				return;
			}
			this.openCaseStatusModal();
		} else {
			let data = {
				id: this.uId,
				mark_for_closure: this.mark_for_closure
			}
			this.mark_loader = true;
			this.apiService.updateCaseDetails(data).subscribe({
				next: (data: any) => {
					this.mark_loader = false;
					this.toastr.success('Updated successfully', 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					this.getCaseDetails();
				}, error: (error) => {
					this.mark_loader = false;
					this.toastr.error('Something went wrong', 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				},
			});
		}
	}

	reportSentChange() {
		let data = {
			id: this.uId,
			closure_report_sent: this.closure_report_sent
		}
		this.rep_sent_loader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.rep_sent_loader = false;
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.rep_sent_loader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	openTriageModal() {
		$("#triageModal").modal("show");
	}

	getTriage(val: any) {
		return this.triageList.find((triage) => triage.val == val) || { color: "dark-custom", text: "Assign Triage" };
	}

	saveTriage() {
		let data = {
			id: this.uId,
			triage: this.triageCode
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#triageModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	openSignOffByModal() {
		$("#signOffByModal").modal("show");
	}

	getSignOffName(val: any) {
		if (val == "3C") {
			return "3 Cube";
		}
		if (val == "CO") {
			return "Company";
		}
		return "";
	}

	saveSignOffBy() {
		let data = {
			id: this.uId,
			sign_off_by: this.sign_off_by_model
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#signOffByModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getCaseCatList() {
		this.apiService.getAllCaseCategories().subscribe({
			next: (data: any) => {
				this.allCaseCategories = data;
			}, error: (error) => {
				this.allCaseCategories = [];
			},
		});
	}

	openCaseCatModal() {
		$("#caseCategoryModal").modal("show");
	}

	saveCaseCat() {
		let data = {
			id: this.uId,
			case_category_id: this.case_category_id,
			work_related: this.work_related,
			work_related_by: this.caseDetails['work_related_by'],
			work_related_date: this.reverseDate(this.caseDetails['work_related_date'])
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#caseCategoryModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getFitnesStatus() {
		this.apiService.getFitnesStatus().subscribe({
			next: (data: any) => {
				this.fitnessStatusList = data;
			}, error: (error) => {
				this.fitnessStatusList = [];
			},
		});
	}

	getFitnessStatusName(id: any) {
		return this.fitnessStatusList.find((ft) => ft.id == id) || { id: null, name: "" };
	}

	validateForCaseClosure() {
		let msgList = this.validateForReadyToBill();
		if (!this.ready_to_bill) {
			msgList.push('<li>Ensure case is marked as <strong>"Ready to bill"<strong></li>')
		}
		return msgList;
	}

	reopenLoader = false;
	reopenCase() {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to reopen case?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Reopen'
		}).then((result) => {
			if (result.value) {
				let data = {
					id: this.uId,
					status_id: 1,
					/* mark_for_closure: false */
				}
				this.reopenLoader = true;
				this.apiService.updateCaseDetails(data).subscribe({
					next: (data: any) => {
						this.reopenLoader = false;
						this.toastr.success('Updated successfully', 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.getCaseDetails();
					}, error: (error) => {
						this.reopenLoader = false;
						this.toastr.error('Something went wrong', 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					},
				});
			}
		})
	}

	reverseMarkForClosure() {
		this.mark_for_closure = !this.mark_for_closure;
	}

	openCaseStatusModal() {
		if (this.navbar.userAccess?.Appointments != 'Full') {
			this.toastr.warning("Sorry, You don't have access for this", 'No access', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		$("#caseStatusModal").modal("show");
		this.formSubmitted = false;
		this.moduleForm.markAsPristine();
		this.moduleForm.markAsUntouched();
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	saveCaseStatusOld() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		let data = {
			id: this.uId,
			closure_notes: this.f.closure_notes.value,
			status4_id: this.f.status4_id.value,
			mark_for_closure: this.mark_for_closure
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#caseStatusModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	saveCaseStatus() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		let data = {
			id: this.uId,
			closure_notes: this.f.closure_notes.value,
			status4_id: this.f.status4_id.value,
			mark_for_closure: this.mark_for_closure,
			status_id: 2
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#caseStatusModal").modal("hide");
				this.followupDetailsComponent.saveFollowUp_B();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	firstCallToGetCaseDetailsDone = false;
	/* initCandConnType = ""; */
	getCaseDetails() {
		this.getCaseReminders();
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				data["expected_closure_date_display"] = data["expected_closure_date"];
				data["arrival_date_display"] = data["arrival_date"];
				data["fitness_date_display"] = data["fitness_date"];
				data["surgery_date_display"] = data["surgery_date"];
				data["hospitalized_date_display"] = data["hospitalized_date"];
				data["expected_closure_date"] = this.apiService.getDateFromDateString(data["expected_closure_date"]);
				data["arrival_date"] = this.apiService.getDateFromDateString(data["arrival_date"]);
				data["fitness_date"] = this.apiService.getDateFromDateString(data["fitness_date"]);
				data["surgery_date"] = this.apiService.getDateFromDateString(data["surgery_date"]);
				data["hospitalized_date"] = this.apiService.getDateFromDateString(data["hospitalized_date"]);
				this.caseDetails = data;
				this.channelName = this.caseDetails.id.toString();
				this.userId = this.user.id;/* Math.floor(Math.random() * 100) + 1; */
				this.userName = `doc_${this.user.id}`;
				this.candidateUserName = `candidate_${this.caseDetails.candidate}`;
				/* this.screenUserId = this.userId + 1; */
				/* this.otherSideUserId = this.followUpDetails.case_id.candidate.id;
				this.otherSideScreenUserId = this.otherSideUserId + 1; */

				/* if (this.caseDetails["hospitalized_required_date"]) {
					this.caseDetails["hospitalized_required_date"] = this.caseDetails["hospitalized_required_date"].split("-").reverse().join("-");
				}
				if (this.caseDetails["diagnosis_date"]) {
					this.caseDetails["diagnosis_date"] = this.caseDetails["diagnosis_date"].split("-").reverse().join("-");
				}
				if (this.caseDetails["disability_date"]) {
					this.caseDetails["disability_date"] = this.caseDetails["disability_date"].split("-").reverse().join("-");
				}
				if (this.caseDetails["surgery_required_date"]) {
					this.caseDetails["surgery_required_date"] = this.caseDetails["surgery_required_date"].split("-").reverse().join("-");
				}
				if (this.caseDetails["expected_closure_date_date"]) {
					this.caseDetails["expected_closure_date_date"] = this.caseDetails["expected_closure_date_date"].split("-").reverse().join("-");
				}
				if (this.caseDetails["arrival_date_updated_date"]) {
					this.caseDetails["arrival_date_updated_date"] = this.caseDetails["arrival_date_updated_date"].split("-").reverse().join("-");
				}
				if (this.caseDetails["fitness_date_updated_date"]) {
					this.caseDetails["fitness_date_updated_date"] = this.caseDetails["fitness_date_updated_date"].split("-").reverse().join("-");
				} */
				this.mark_for_closure = this.caseDetails.mark_for_closure;
				this.closure_report_sent = this.caseDetails.closure_report_sent;
				this.ready_to_bill = this.caseDetails.ready_to_bill;
				this.candidate_no_dues = this.caseDetails.candidate_no_dues;
				this.vendor_no_dues = this.caseDetails.vendor_no_dues;
				this.triageCode = this.caseDetails.triage;
				this.sign_off_by_model = this.caseDetails.sign_off_by || "";
				this.assigned_sc_agent_id = this.caseDetails.assigned_sc_agent?.id;
				this.work_related = this.caseDetails.work_related;
				this.case_category_id = this.caseDetails.case_category_id ? parseInt(this.caseDetails.case_category_id) : null;
				this.f.status4_id.setValue(this.caseDetails.status4);
				this.f.closure_notes.setValue(this.caseDetails.closure_notes);
				this.subsymptoms = data.sub_symptoms != null ? Object.keys(data.sub_symptoms).map(key => data.sub_symptoms[key]) : [];
				this.getFolloupBillsByCase();
				if (this.caseDetails.medications_onboard) {
					for (let i = 0; i < this.caseDetails.medications_onboard.length; i++) {
						this.caseDetails.medications_onboard[i].isSaved = true;
						try {
							if (this.caseDetails.medications_onboard[i].medDate) {
								this.caseDetails.medications_onboard[i].medDate = this.caseDetails.medications_onboard[i].medDate.split("T")[0];
								this.caseDetails.medications_onboard[i].medDate = this.caseDetails.medications_onboard[i].medDate.replace(/-/g, "/");
							}
							/* if (!isNaN(this.caseDetails.medications_onboard[i].noOfDays) && this.caseDetails.medications_onboard[i].medDate) {
								let medDate: any = new Date(this.caseDetails.medications_onboard[i].medDate);
								medDate.setHours(0, 0, 0, 0);
								let noOfDays: any = parseInt(this.caseDetails.medications_onboard[i].noOfDays);
								const today: any = new Date();
								today.setHours(0, 0, 0, 0);
								const diffTime: any = Math.abs(today - medDate);
								const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
								if (diffDays >= noOfDays && this.caseDetails.medications_onboard[i].status == "Started") {
									this.caseDetails.medications_onboard[i].status = "Completed";
								}
							} */
						} catch (error) { }
					}
				}
				this.autoReadyToBill();
				this.autoMarkForClosure();
				if (!this.firstCallToGetCaseDetailsDone) {
					this.messagingService.login().then(userCredential => {
						this.unreadCount$ = this.getUnreadMsgCount();
					}).catch(error => { });
					if (
						this.chatAction &&
						this.chatAction != 'no' &&
						(
							this.navbar.userAccess?.Chat == "Full" ||
							this.navbar.userAccess?.Chat == "Readonly"
						)
					) {
						if (this.chatAction == "video") {
							this.openForm();
							this.initJoinCall(true, false);
						} else if (this.chatAction == "audio") {
							this.openForm();
							this.initJoinCall(false, false);
						} else if (this.chatAction == "chat") {
							this.openForm();
						}
					}
					this.listenForCall();
				}
				this.firstCallToGetCaseDetailsDone = true;
				/* this.checkRemoteOnline(); */
				/* this.checkRemoteOnlineNew(); */
			}, error: (error) => {
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	listenForCall() {
		const colRef = collection(this.firestore, 'call');
		const callQuery = query(
			colRef,
			where('channel', '==', this.channelName),
			where('from', '==', "candidate")
		);
		let isInitialLoad = true;
		onSnapshot(callQuery, (snapshot) => {
			if (isInitialLoad) {
				isInitialLoad = false;
				return;
			}
			snapshot.docChanges().forEach((change) => {
				if (change.type === 'added') {
					const document = {
						id: change.doc.id,
						...change.doc.data()
					};
					if (document["action"] == "disconnect" && document["channel"] == this.channelName) {
						console.log("Call disconnected by candidate", document);
						try {
							this.leave();
							this.closeForm();
						} catch (error) { }
					}
				}
			});
		});
	}

	getFollowup() {
		this.apiService.getFollowupList({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.loadingFollowUp = false;
				this.followupList = data.data;
				/* if (!this.activeRoute.children.length && this.followupList.length) {
					this.router.navigate(["follow-up",this.followupList[0].enc_id], { relativeTo: this.activeRoute });
				} */
				if (this.followupList.length) {
					if (this.selectedFollowUpId) {
						this.selectFollowUp(this.selectedFollowUpId);
					} else {
						let url = this.router.url.replace("empty", this.followupList[0].enc_id);
						try {
							url = decodeURIComponent(url);
						} catch (error) { }
						this.router.navigate([url]);
					}
				}
				this.autoReadyToBill();
				this.autoMarkForClosure();
			}, error: (error) => {
				this.loadingFollowUp = false;
				this.followupList = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	selectFollowUp(enc_id: any) {
		/* this.selectedFollowUpId = null; */
		setTimeout(() => {
			this.selectedFollowUpId = enc_id;
			/* setTimeout(() => {
				try {
					this.followupDetailsComponent.initComponent();
				} catch (error) { }
			}, 0); */
		}, 0);
	}

	getFileName(filepath: string) {
		try {
			return filepath.split("/").pop() || "";
		} catch (error) {
			return filepath;
		}
	}

	getFolloupBillsByCase() {
		this.loadingBilling = true;
		this.apiService.getFolloupBillsByCase({ id: this.caseDetails.id }).subscribe({
			next: (data: any) => {
				data.data.map((bill: any) => {
					bill.files = bill.files === null ? [] : bill.files;
					bill.gpay_files = bill.gpay_files === null ? [] : bill.gpay_files;
					bill.qrcode_files = bill.qrcode_files === null ? [] : bill.qrcode_files;
					return bill
				});
				this.loadingBilling = false;
				this.followUpBillsData = data.data;
				this.autoReadyToBill();
				/* this.autoMarkForClosure(); */
			}, error: (error) => {
				this.loadingBilling = false;
				this.followUpBillsData = [];
			}
		})
	}

	getBillCategoryList() {
		this.apiService.getAllBillList().subscribe({
			next: (data: any) => {
				this.billCategoryList = data;
			}, error: (error) => {
				this.billCategoryList = [];
			}
		})
	}

	openBillModal() {
		/* let billingDetailsForEdit: any[] = JSON.parse(JSON.stringify(this.followUpBillsData));
		billingDetailsForEdit.forEach((bill: any) => {
			bill.date = this.apiService.getDateFromDateString(bill.date);
		});
		this.billingDetailsForEdit = billingDetailsForEdit; */
		this.selectedFollowupForBilling = null;
		this.filterBills();
		$("#billingModalAppt").modal("show");
	}

	closeBillingModal() {
		$("#billingModalAppt").modal("hide");
	}

	selectedFollowupForBilling: any = null;
	filterBills() {
		let followUpBillsData: any[] = JSON.parse(JSON.stringify(this.followUpBillsData));
		let billingDetailsForEdit: any[] = followUpBillsData.filter((bill: any) => {
			if (this.selectedFollowupForBilling) {
				return bill.followup == this.selectedFollowupForBilling;
			} else {
				return true;
			}
		});
		billingDetailsForEdit.forEach((bill: any) => {
			bill.date = this.apiService.getDateFromDateString(bill.date);
		});
		this.billingDetailsForEdit = billingDetailsForEdit;
	}

	saveBilling() {
		let billing: any[] = [];
		let allowedDate = addDays(new Date(), 1);
		let len = this.billingDetailsForEdit.length;
		for (let i = 0; i < len; i++) {
			let bill = this.billingDetailsForEdit[i];
			if (bill.date && isBefore(allowedDate, bill.date)) {
				this.toastr.error("Future date is not allowed", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			if (!bill.notes) {
				this.toastr.error("Please enter notes", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			if (bill.amount === "" || bill.amount == null || bill.amount <= 0) {
				this.toastr.error("Please enter valid amount", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			billing.push({
				"id": bill.id || "",
				"case_id": this.caseDetails.id,
				"followup_id": bill.followup,
				"category_id": bill.category,
				"date": this.apiService.getDateStringFromDate(bill.date),
				"notes": bill.notes,
				"amount": bill.amount,
				"is_paid": bill.is_paid,
				"is_approved": bill.is_approved,
				"reimbursement": bill.reimbursement,
				"files": bill.files,
				"gpay_files": bill.gpay_files,
				"qrcode_files": bill.qrcode_files,
			})
		};
		this.saveBillLoader = true;
		this.apiService.sendFollowUpBills(billing).subscribe({
			next: (data: any) => {
				this.saveBillLoader = false;
				this.toastr.success("Billing saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				/* this.closeBillingModal(); */
				this.getFolloupBillsByCase();
			}, error: (error: any) => {
				this.saveBillLoader = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	saveBillLoaderSingle: any = null;
	saveSingleBilling(i: number) {
		let billing: any[] = [];
		let allowedDate = addDays(new Date(), 1);
		let bill = this.billingDetailsForEdit[i];
		if (bill.date && isBefore(allowedDate, bill.date)) {
			this.toastr.error("Future date is not allowed", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (!bill.notes) {
			this.toastr.error("Please enter notes", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (bill.amount === "" || bill.amount == null || bill.amount <= 0) {
			this.toastr.error("Please enter valid amount", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		billing.push({
			"id": bill.id || "",
			"case_id": this.caseDetails.id,
			"followup_id": bill.followup,
			"category_id": bill.category,
			"date": this.apiService.getDateStringFromDate(bill.date),
			"notes": bill.notes,
			"amount": bill.amount,
			"is_paid": bill.is_paid,
			"is_approved": bill.is_approved,
			"reimbursement": bill.reimbursement,
			"files": bill.files,
			"gpay_files": bill.gpay_files,
			"qrcode_files": bill.qrcode_files,
		})
		this.saveBillLoaderSingle = i;
		this.apiService.sendFollowUpBills(billing).subscribe({
			next: (data: any) => {
				this.saveBillLoaderSingle = null;
				this.toastr.success("Billing saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				/* this.closeBillingModal(); */
				this.getFolloupBillsByCase();
			}, error: (error: any) => {
				this.saveBillLoaderSingle = null;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	removeBillingDetails(index: number) {
		if (this.billingDetailsForEdit[index].used_in_invoice) {
			return;
		}
		if (this.billingDetailsForEdit[index].id) {
			Swal.fire({
				title: 'Warning',
				text: 'Are you sure you want to delete record?',
				icon: 'warning',
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#f23022'
			}).then((result) => {
				if (result.value) {
					this.apiService.deleteFollowUpBills({ id: this.billingDetailsForEdit[index].enc_id }).subscribe({
						next: data => {
							Swal.fire('Success', 'Record Deleted Successfully.', 'success');
							this.billingDetailsForEdit.splice(index, 1);
							this.getBillingTotal();
							this.getFolloupBillsByCase();
						}, error: (error) => {
							if (error.status == 401) { return }
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					});
				}
			})
		} else {
			this.billingDetailsForEdit.splice(index, 1);
			this.getBillingTotal();
		}
	}

	getBillingTotal() {
		try {
			let amount = 0;
			this.billingDetailsForEdit.forEach((bill: any) => {
				if (!isNaN(bill.amount)) {
					amount += bill.amount;
				}
			});
			this.amount = amount;
		} catch (error) {
			this.amount = 0;
		}
	}

	allowedBillFiles = allowedBillFiles;
	billFileUploaded(filepath: any, index: number) {
		if (!this.billingDetailsForEdit[index].files) {
			this.billingDetailsForEdit[index].files = [];
		}
		this.billingDetailsForEdit[index].files.push(filepath);
	}

	amountFetched(amountData: any, index: number) {
		this.billingDetailsForEdit[index].amount = amountData;
		this.toastr.success("Fetched " + amountData, 'Success', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}

	deleteBillFile(name: string, i: number, j: number) {
		if (this.billingDetailsForEdit[i].used_in_invoice) {
			return;
		}
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				let billObj = JSON.parse(JSON.stringify(this.billingDetailsForEdit[i]));
				billObj.files.splice(j, 1);
				let payload = {
					files: billObj.files,
					id: billObj.id,
					file: name
				};
				this.apiService.billFileDelete(payload).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
				/* this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				}); */
			}
		})
	}

	allowedBillGPayFiles = allowedBillGPayFiles;
	gpayFileUploaded(filepath: any, index: number) {
		if (!this.billingDetailsForEdit[index].gpay_files) {
			this.billingDetailsForEdit[index].gpay_files = [];
		}
		this.billingDetailsForEdit[index].gpay_files.push(filepath);
	}

	deleteBillGpayFile(name: string, i: number, j: number) {
		if (this.billingDetailsForEdit[i].used_in_invoice) {
			return;
		}
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				let billObj = JSON.parse(JSON.stringify(this.billingDetailsForEdit[i]));
				billObj.gpay_files.splice(j, 1);
				let payload = {
					gpay_files: billObj.gpay_files,
					id: billObj.id,
					file: name
				};
				this.apiService.billFileDelete(payload).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].gpay_files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
				/* this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].gpay_files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				}); */
			}
		})
	}

	allowedBillQRFiles = allowedBillQRFiles;
	qrFileUploaded(filepath: any, index: number) {
		if (!this.billingDetailsForEdit[index].qrcode_files) {
			this.billingDetailsForEdit[index].qrcode_files = [];
		}
		this.billingDetailsForEdit[index].qrcode_files.push(filepath);
	}

	deleteBillQRFile(name: string, i: number, j: number) {
		if (this.billingDetailsForEdit[i].used_in_invoice) {
			return;
		}
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				let billObj = JSON.parse(JSON.stringify(this.billingDetailsForEdit[i]));
				billObj.qrcode_files.splice(j, 1);
				let payload = {
					qrcode_files: billObj.qrcode_files,
					id: billObj.id,
					file: name
				};
				this.apiService.billFileDelete(payload).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].qrcode_files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
				/* this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].qrcode_files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				}); */
			}
		})
	}

	deleteFollowUp(id: any) {
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to delete followup?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoader = id;
				const data = { id };
				this.apiService.deleteFollowUp(data).subscribe({
					next: (res: any) => {
						this.showDeleteLoader = null;
						this.getFollowup();
						this.toastr.success('Follow Up Deleted', 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.router.navigate(['/app/appt-details', 'no', this.uId, 'empty']);
					}, error: (error) => {
						this.showDeleteLoader = null;
						this.toastr.error(error.error, 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	getFollowUpStatusClass(statusId: any) {
		if (statusId == 2) {
			return "bg-success";
		} else if (statusId == 1) {
			return "bg-warning";
		} else {
			return "bg-danger";
		}
	}

	getClass(value: number): string {
		if (value < 90) {
			return 'bg-success';
		} else if (value >= 90 && value <= 130) {
			return 'bg-warning-custom';
		} else {
			return 'bg-danger';
		}
	}

	deleteFollowupFile(name: string, i: number, j: number, k: number) {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.caseDetails.opd_notes[i].lab_test_files[j].files.splice(k, 1);
						this.saveFiles(i);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	saveFiles(index: number) {
		let files: any[] = [];
		let len = this.caseDetails.opd_notes[index].lab_test_files.length;
		for (let i = 0; i < len; i++) {
			let bill = this.caseDetails.opd_notes[index].lab_test_files[i];
			files.push({
				"id": bill.id,
				"followup_id": this.caseDetails.opd_notes[index].id,
				"file_url": bill.files,
			})
		};
		this.apiService.saveFollowUpFiles(files).subscribe({
			next: (data: any) => {
				/* this.getCaseDetails(); */
				this.apiService.sendFollowUpFilesRefreshEvent();
			}, error: (error: any) => {
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	keyEvalModal() {
		$("#keyEvalModal").modal("show");
	}

	keyEvalChanged(key: any) {
		let by: any = this.navbar.user?.first_name + " " + this.navbar.user?.last_name;
		let date: any = this.reverseDate(this.apiService.getDateStringFromDate(new Date()));
		if (key == "surgery_required") {
			if (!this.caseDetails["surgery_required"]) {
				by = null;
				date = null;
			}
			this.caseDetails["surgery_required_by"] = by;
			this.caseDetails["surgery_required_date"] = date;
		} else if (key == "disability") {
			if (!this.caseDetails["disability"]) {
				by = null;
				date = null;
			}
			if (!this.caseDetails["disability"] || this.caseDetails["disability"] == "No") {
				this.caseDetails["disability_per"] = null;
				this.caseDetails["disability_notes"] = null;
			}
			this.caseDetails["disability_by"] = by;
			this.caseDetails["disability_date"] = date;
		} else if (key == "diagnosis") {
			if (!this.caseDetails["diagnosis"]) {
				by = null;
				date = null;
			}
			this.caseDetails["diagnosis_by"] = by;
			this.caseDetails["diagnosis_date"] = date;
		} else if (key == "hospitalized_required") {
			if (!this.caseDetails["hospitalized_required"]) {
				by = null;
				date = null;
			}
			this.caseDetails["hospitalized_required_by"] = by;
			this.caseDetails["hospitalized_required_date"] = date;
		} else if (key == "expected_closure_date") {
			if (!this.caseDetails["expected_closure_date"]) {
				by = null;
				date = null;
			}
			this.caseDetails["expected_closure_date_by"] = by;
			this.caseDetails["expected_closure_date_date"] = date;
		} else if (key == "arrival_date") {
			if (!this.caseDetails["arrival_date"]) {
				by = null;
				date = null;
			}
			this.caseDetails["arrival_date_by"] = by;
			this.caseDetails["arrival_date_updated_date"] = date;
		} else if (key == "fitness_date") {
			if (!this.caseDetails["fitness_date"]) {
				by = null;
				date = null;
			}
			this.caseDetails["fitness_date_by"] = by;
			this.caseDetails["fitness_date_updated_date"] = date;
		} else if (key == "work_related") {
			if (!this.caseDetails["work_related"]) {
				by = null;
				date = null;
			}
			this.caseDetails["work_related_by"] = by;
			this.caseDetails["work_related_date"] = date;
		}
	}

	reverseDate(dateStr: string) {
		if (dateStr) {
			try {
				return dateStr.split("-").reverse().join("-");
			} catch (error) {
				return dateStr;
			}
		} else {
			return dateStr;
		}
	}

	saveKeyEval() {
		if (!this.caseDetails['diagnosis']) {
			this.toastr.error('Please enter Diagnosis', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (!this.caseDetails['due_to']) {
			this.toastr.error('Please enter Due to', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let data: any = {
			id: this.uId,
			icd_code: this.caseDetails['icd_code'],
			due_to: this.caseDetails['due_to'],
			expected_treatment_cost: this.caseDetails['expected_treatment_cost'],
			expected_closure_date: this.apiService.getDateStringFromDate(this.caseDetails['expected_closure_date']) || null,
			expected_closure_date_by: this.caseDetails['expected_closure_date_by'],
			expected_closure_date_date: this.reverseDate(this.caseDetails['expected_closure_date_date']),

			arrival_date: this.apiService.getDateStringFromDate(this.caseDetails['arrival_date']) || null,
			arrival_date_by: this.caseDetails['arrival_date_by'],
			arrival_date_updated_date: this.reverseDate(this.caseDetails['arrival_date_updated_date']),

			fitness_date: this.apiService.getDateStringFromDate(this.caseDetails['fitness_date']) || null,
			fitness_date_by: this.caseDetails['fitness_date_by'],
			fitness_date_updated_date: this.reverseDate(this.caseDetails['fitness_date_updated_date']),

			diagnosis: this.caseDetails['diagnosis'],
			diagnosis_by: this.caseDetails['diagnosis_by'],
			diagnosis_date: this.reverseDate(this.caseDetails['diagnosis_date']),

			surgery_required: this.caseDetails['surgery_required'],
			surgery_date: this.apiService.getDateStringFromDate(this.caseDetails['surgery_date']) || null,
			surgery_required_by: this.caseDetails['surgery_required_by'],
			surgery_required_date: this.reverseDate(this.caseDetails['surgery_required_date']),

			hospitalized_required: this.caseDetails['hospitalized_required'],
			hospitalized_date: this.apiService.getDateStringFromDate(this.caseDetails['hospitalized_date']) || null,
			hospitalized_required_by: this.caseDetails['hospitalized_required_by'],
			hospitalized_required_date: this.reverseDate(this.caseDetails['hospitalized_required_date']),

			disability: this.caseDetails['disability'],
			disability_per: this.caseDetails['disability_per'],
			disability_notes: this.caseDetails['disability_notes'],
			disability_by: this.caseDetails['disability_by'],
			disability_date: this.reverseDate(this.caseDetails['disability_date'])
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#keyEvalModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	isKeyEvalIncomplete() {
		try {
			if (
				/* this.caseDetails?.hospitalized_required &&
				this.caseDetails?.surgery_required && */
				this.caseDetails?.disability &&
				this.caseDetails?.expected_closure_date &&
				this.caseDetails?.arrival_date &&
				this.caseDetails?.fitness_date &&
				this.caseDetails?.icd_code &&
				this.caseDetails?.due_to &&
				this.caseDetails?.expected_treatment_cost &&
				this.caseDetails?.diagnosis
			) {
				if (this.caseDetails?.disability == "Yes" && !this.caseDetails?.disability_per) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		} catch (error) {
			return true;
		}
	}

	showHospitalizationDate() {
		return this.caseDetails?.hospitalized_required == 'Yes' || this.caseDetails?.hospitalized_required == 'Discharged' ? true : false;
	}

	showSurgeryDate() {
		return this.caseDetails?.surgery_required == 'Yes' ? true : false;
	}

	showDisabilityFields() {
		return this.caseDetails?.disability == 'Yes' || this.caseDetails?.disability == 'Limited' ? true : false;
	}

	openAssigneeModal() {
		$("#assigneeModal").modal("show");
	}

	getAllDoctors() {
		/* this.apiService.getDoctorList({}).subscribe({
			next: (data: any) => {
				this.doctorList = data.data.filter((doc) => doc.type_name == "Doctor" || doc.type == 1);
			}, error: (error) => {
				this.doctorList = [];
			},
		}); */
		this.doctorList = this.navbar.filterDoctors().filter((doc) => doc.type_name == "Doctor" || doc.type == 1);
	}

	saveAssignee() {
		let data = {
			id: this.uId,
			assigned_sc_agent_id: this.assigned_sc_agent_id
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#assigneeModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getAllFollowUpStatus() {
		this.apiService.getAllFollowUpStatus().subscribe({
			next: (data: any) => {
				let groupedData = data.data.reduce((prev: any, current: any) => {
					const key = current.category;
					if (!prev[key]) {
						prev[key] = [];
					}
					prev[key].push(current);
					return prev;
				}, {});
				this.hospStatusList = groupedData.Hospitalization;
				this.surgeryStatusList = groupedData.Surgery;
				/* this.disablityStatusList = groupedData.Disablity; */
				this.status3List = groupedData.Status3;

				this.followUpStatusList = groupedData.FollowUp;
				this.status4List = groupedData.Status4;
			}, error: (error) => {
				this.hospStatusList = [];
				this.surgeryStatusList = [];
				/* this.disablityStatusList = []; */
				this.status3List = [];
				this.followUpStatusList = [];
				this.status4List = [];
			},
		});
	}

	openCaseIdModal() {
		this.searchControl.setValue(null);
		this.detailsFromCaseId = null;
		$("#caseIdModal").modal("show");
	}

	closeCaseIdModal() {
		$("#caseIdModal").modal("hide");
		this.searchControl.setValue(null);
		this.detailsFromCaseId = null;
	}

	getHCCaseDetails() {
		if (this.searchControl.value) {
			this.fetchCaseIdDetailsLoader = true;
			this.apiService.fetchHcData({ caseId: this.searchControl.value }).subscribe({
				next: (response: any) => {
					this.fetchCaseIdDetailsLoader = false;
					if (response != "Please check all the required parameters.") {
						const detailsFromCaseId: any = response;
						if (typeof detailsFromCaseId.medicines == "string") {
							try {
								detailsFromCaseId.medicines = detailsFromCaseId.medicines ? JSON.parse(detailsFromCaseId.medicines) : [];
								if (detailsFromCaseId.medicines == null) {
									detailsFromCaseId.medicines = [];
								}
							} catch (error) {
								detailsFromCaseId.medicines = [];
							}
						} else {
							try {
								detailsFromCaseId.medicines = detailsFromCaseId.medicines ? JSON.parse(JSON.stringify(detailsFromCaseId.medicines)) : [];
								if (detailsFromCaseId.medicines == null) {
									detailsFromCaseId.medicines = [];
								}
							} catch (error) {
								detailsFromCaseId.medicines = [];
							}
						}
						for (let i = 0; i < detailsFromCaseId.medicines.length; i++) {
							detailsFromCaseId.medicines[i].isSaved = true;
							try {
								if (detailsFromCaseId.medicines[i].medDate) {
									detailsFromCaseId.medicines[i].medDate = detailsFromCaseId.medicines[i].medDate.split("T")[0];
									detailsFromCaseId.medicines[i].medDate = detailsFromCaseId.medicines[i].medDate.replace(/-/g, "/");
								}
								if (!isNaN(detailsFromCaseId.medicines[i].noOfDays) && detailsFromCaseId.medicines[i].medDate) {
									let medDate: any = new Date(detailsFromCaseId.medicines[i].medDate);
									medDate.setHours(0, 0, 0, 0);
									let noOfDays: any = parseInt(detailsFromCaseId.medicines[i].noOfDays);
									const today: any = new Date();
									today.setHours(0, 0, 0, 0);
									const diffTime: any = Math.abs(today - medDate);
									const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
									if (diffDays >= noOfDays && detailsFromCaseId.medicines[i].status == "Started") {
										detailsFromCaseId.medicines[i].status = "Completed";
									}
								}
							} catch (error) { }
						}
						try {
							detailsFromCaseId.symptoms = detailsFromCaseId.symptoms !== null ? detailsFromCaseId.symptoms : [];
						} catch (error) {
							detailsFromCaseId.symptoms = [];
						}
						try {
							detailsFromCaseId.subsymptoms = detailsFromCaseId.subsymptoms !== null ? detailsFromCaseId.subsymptoms : [];
						} catch (error) {
							detailsFromCaseId.subsymptoms = [];
						}
						let reported_as = "";
						if (detailsFromCaseId.symptoms) {
							try {
								const len = detailsFromCaseId.symptoms.length;
								for (let i = 0; i < len; i++) {
									const len1 = reported_as_list.length;
									for (let j = 0; j < len1; j++) {
										if (detailsFromCaseId.symptoms[i].toLowerCase() == reported_as_list[j]) {
											reported_as = detailsFromCaseId.symptoms[i];
										}
									}
								}
							} catch (error) { }
						}
						detailsFromCaseId.reported_as = reported_as;
						let subsymptoms: any[] = [];
						if (detailsFromCaseId.subsymptoms) {
							try {
								Object.entries(detailsFromCaseId.subsymptoms).forEach(([key, value]) => {
									subsymptoms.push(value);
								});
							} catch (error) { }
						}
						detailsFromCaseId.subsymptoms = subsymptoms;
						detailsFromCaseId.scNationalityId = null;
						detailsFromCaseId.scRankId = null;
						detailsFromCaseId.scCompanyId = null;
						detailsFromCaseId.scVesselId = null;
						if (detailsFromCaseId.nationality) {
							let len = this.countryList.length;
							for (let i = 0; i < len; i++) {
								try {
									if (this.countryList[i].nationality.toLowerCase() == detailsFromCaseId.nationality.toLowerCase()) {
										detailsFromCaseId.scNationalityId = this.countryList[i].id;
										break;
									}
								} catch (error) { }
							}
						}
						if (detailsFromCaseId.rank) {
							let len = this.rankList.length;
							for (let i = 0; i < len; i++) {
								try {
									if (this.rankList[i].rank.toLowerCase() == detailsFromCaseId.rank.toLowerCase()) {
										detailsFromCaseId.scRankId = this.rankList[i].rank_id;
										break;
									}
								} catch (error) { }
							}
						}
						this.detailsFromCaseId = detailsFromCaseId;
						if (detailsFromCaseId.company) {
							let len = this.companyList.length;
							for (let i = 0; i < len; i++) {
								try {
									if (this.companyList[i].com_name.toLowerCase() == this.detailsFromCaseId.company.toLowerCase()) {
										this.detailsFromCaseId.scCompanyId = this.companyList[i].id;
										if (this.detailsFromCaseId.vessel) {
											this.apiService.getVessel({ company: this.detailsFromCaseId.scCompanyId }).subscribe({
												next: (data1: any) => {
													let vesselList: any[] = data1.data;
													let len = vesselList.length;
													for (let i = 0; i < len; i++) {
														try {
															if (vesselList[i].vessel_name.toLowerCase() == this.detailsFromCaseId.vessel.toLowerCase()) {
																this.detailsFromCaseId.scVesselId = vesselList[i].id;
																break;
															}
														} catch (error) { }
													}
												}, error: (error) => { }
											});
										}
										break;
									}
								} catch (error) { }
							}
						}
					}
				}, error: (error: any) => {
					this.fetchCaseIdDetailsLoader = false;
					this.detailsFromCaseId = null;
					if (error.status == 401) { return }
					if (error.status == 400) {
						this.toastr.warning("Appointment with this Case-Id already exists.", 'Warning', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					} else if (error.status == 500) {
						this.toastr.warning(error.error, 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					} else {
						this.toastr.error("No details found.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				}
			});
		}
	}

	getFrequencyText(obj: any) {
		let textArr: any = [];
		if (obj.morning) {
			textArr.push("Morning");
		}
		if (obj.afternoon) {
			textArr.push("Afternoon");
		}
		if (obj.evening) {
			textArr.push("Evening");
		}
		if (obj.sos) {
			textArr.push("SOS");
		}
		return textArr.join(", ");
	}

	useCaseDetails() {
		if (!this.detailsFromCaseId) {
			this.toastr.error("No case details.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let candidate: any = {
			id: this.caseDetails.candidate,
			f_name: this.detailsFromCaseId.f_name,
			l_name: this.detailsFromCaseId.l_name,
			email: this.detailsFromCaseId.email,
			gender: this.detailsFromCaseId.gender,
			dob: this.detailsFromCaseId.dob,
			/* nationality_id: this.detailsFromCaseId.scNationalityId, */
			address: null,
			country_code: null,
			tel_no: null,
		};
		if (this.detailsFromCaseId.scNationalityId) {
			candidate["nationality_id"] = this.detailsFromCaseId.scNationalityId;
		}
		let data: any = {
			id: this.caseDetails.id,
			candidate,
			crew_id: this.detailsFromCaseId.crew_id,
			symptoms: this.detailsFromCaseId.symptoms,
			sub_symptoms: this.detailsFromCaseId.subsymptoms,
			medications_onboard: this.detailsFromCaseId.medicines,
			initial_complaints: this.detailsFromCaseId.initialDiagnosis,
			sign_off_by: this.detailsFromCaseId.signoff_by,
			sign_off_date: this.detailsFromCaseId.signoff_date,
			assigned_dr_rma: this.detailsFromCaseId.dr_name,
			port_visit_done: this.detailsFromCaseId.port_visit,
			medical_summary: this.detailsFromCaseId.medical_summary,
			reported_as: this.detailsFromCaseId.reported_as,
			case_id: this.detailsFromCaseId.caseId,
			rank: this.detailsFromCaseId.scRankId,
			company: this.detailsFromCaseId.scCompanyId,
			vessel: this.detailsFromCaseId.scVesselId
		};
		/* if(this.detailsFromCaseId.scRankId){
			data["rank"] = this.detailsFromCaseId.scRankId;
		}
		if(this.detailsFromCaseId.scCompanyId){
			data["company"] = this.detailsFromCaseId.scCompanyId;
		}
		if(this.detailsFromCaseId.scVesselId){
			data["vessel"] = this.detailsFromCaseId.scVesselId;
		} */
		this.updateLoader = true;
		this.apiService.createUpdateCase(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				this.closeCaseIdModal();
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error(error.error, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getCaseReminders() {
		this.loadingReminders = true;
		this.apiService.getCaseReminders(this.uId).subscribe({
			next: (data: any) => {
				this.loadingReminders = false;
				this.caseReminder = data;
				this.autoReadyToBill();
				this.autoMarkForClosure();
			}, error: (error) => {
				this.loadingReminders = false;
				this.caseReminder = null;
				this.toastr.error(error.error, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getFeedback() {
		this.loadingFeedback = true;
		this.apiService.getFeedbackQuestions(this.uId).subscribe({
			next: (data: any) => {
				this.loadingFeedback = false;
				let listMain: any[] = [];
				let listSub: any[] = [];
				let len1 = data[1].length;
				let len2 = data[0].length;
				for (let i = 0; i < len1; i++) {
					for (let j = 0; j < len2; j++) {
						if (data[1][i].que_id == data[0][j].quetion) {
							data[1][i].ans_given = data[0][j].ans_given;
							data[1][i].other_text = data[0][j].other_text;
						}
					}
					if (data[1][i].parent_id) {
						listSub.push(data[1][i]);
					} else {
						data[1][i].sub_questions = [];
						listMain.push(data[1][i]);
					}
				}
				let len3 = listMain.length;
				let len4 = listSub.length;
				for (let i = 0; i < len3; i++) {
					for (let j = 0; j < len4; j++) {
						if (listMain[i].que_id == listSub[j].parent_id) {
							listMain[i].sub_questions.push(listSub[j])
						}
					}
				}
				this.feedbackQuestions = listMain;
			}, error: (error) => {
				this.loadingFeedback = false;
				this.feedbackQuestions = [];
				this.toastr.error(error.error, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	showOtherInput(ans_given: any, options: any[]) {
		for (let i = 0; i < options.length; i++) {
			if (options[i].value === ans_given && options[i].display_name === "Other") {
				return true;
			}
		}
		return false;
	}

	submitFeedback() {
		this.saveFeedbackLoader = true;
		let feedback: any[] = [];
		let len1 = this.feedbackQuestions.length;
		for (let i = 0; i < len1; i++) {
			if (this.feedbackQuestions[i].ans_details.length) {
				if (this.feedbackQuestions[i].ans_given || this.feedbackQuestions[i].other_text) {
					feedback.push({
						quetion_id: this.feedbackQuestions[i].que_id,
						ans_given: this.feedbackQuestions[i].ans_given || null,
						other_text: this.feedbackQuestions[i].other_text || null
					})
				}
			} else if (!this.feedbackQuestions[i].ans_details.length && this.feedbackQuestions[i].sub_questions.length) {
				let len2 = this.feedbackQuestions[i].sub_questions.length;
				for (let j = 0; j < len2; j++) {
					if (this.feedbackQuestions[i].sub_questions[j].ans_given || this.feedbackQuestions[i].sub_questions[j].other_text) {
						feedback.push({
							quetion_id: this.feedbackQuestions[i].sub_questions[j].que_id,
							ans_given: this.feedbackQuestions[i].sub_questions[j].ans_given || null,
							other_text: this.feedbackQuestions[i].sub_questions[j].other_text || null
						})
					}
				}
			}
		}
		let payload = {
			case_id: this.caseDetails.id,
			quetions: feedback
		}
		this.apiService.submitFeedback(payload).subscribe({
			next: (data: any) => {
				this.saveFeedbackLoader = false;
				this.toastr.success("Feedback submitted successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getFeedback();
			}, error: (error) => {
				this.saveFeedbackLoader = false;
				this.toastr.error(error.error, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	modalNotesDetail: any = {
		heading: null,
		note: null
	};

	showInModal(heading: any, note: any) {
		this.modalNotesDetail.heading = heading;
		this.modalNotesDetail.note = note;
		$("#displayNoteModal").modal("show");
	}

	showHospModal() {
		$("#hospitalizationViewModal").modal("show");
	}

	showSurgModal() {
		$("#surgeryViewModal").modal("show");
	}

	showDisabilityModal() {
		$("#disabilityViewModal").modal("show");
	}

	showPhysioModal() {
		$("#physiotherapyViewModal").modal("show");
	}

	unlinkFromHC() {
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to unlink case from HC?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Unlink',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.apiService.unlinkFromHC(this.uId).subscribe({
					next: (response: any) => {
						this.toastr.success("Unlinked from HC", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.getCaseDetails();
					}, error: (error) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	signOffDate: any = null;
	openSignOffModal() {
		this.signOffDate = this.apiService.getDateFromDateString(this.caseDetails?.sign_off_date);
		$("#signOffModal").modal("show");
	}

	saveSignOff() {
		let data = {
			id: this.uId,
			sign_off_date: this.apiService.getDateStringFromDate(this.signOffDate)
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#signOffModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	medical_history: any = null;
	openMedHistoryModal() {
		this.medical_history = this.caseDetails?.medical_history;
		$("#medHistoryModal").modal("show");
	}

	saveMedHistory() {
		let data = {
			id: this.uId,
			medical_history: this.medical_history
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#medHistoryModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getPortVisitText(val: any) {
		if (val == "No" || val == false || !val) {
			return "NA";
		} else {
			return val;
		}
	}

	getHandover() {
		if (this.uId) {
			this.loadingHandover = true;
			this.apiService.getFollowupList({ id: this.uId, type: 5 }).subscribe({
				next: (data: any) => {
					this.loadingHandover = false;
					this.nonMedicalList = data.data;
				}, error: (error) => {
					this.loadingHandover = false;
					this.nonMedicalList = [];
					this.toastr.error('Something went wrong', 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				},
			});
		}
	}

	rank: any = null;

	openRankModal() {
		this.rank = this.caseDetails?.rank;
		$("#rankModal").modal("show");
	}

	saveRank() {
		let data = {
			id: this.uId,
			rank: this.rank
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#rankModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	address: any = null;

	openAddressModal() {
		this.address = this.caseDetails?.address;
		$("#addressModal").modal("show");
	}

	saveAddress() {
		let data = {
			id: this.uId,
			address: this.address
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#addressModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	crew_id: any = null;

	openCrewIdModal() {
		this.crew_id = this.caseDetails?.crew_id;
		$("#crewIdModal").modal("show");
	}

	saveCrewId() {
		let data = {
			id: this.uId,
			crew_id: this.crew_id
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#crewIdModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	crew_chronic_conditions: any = null;
	openChronicModal() {
		this.crew_chronic_conditions = this.caseDetails?.crew_chronic_conditions;
		$("#chronicModal").modal("show");
	}

	saveChronic() {
		let data = {
			id: this.uId,
			crew_chronic_conditions: this.crew_chronic_conditions
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				$("#chronicModal").modal("hide");
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	validateForReadyToBill() {
		let msgList: string[] = this.validateForMarkForClosure();
		if (!this.mark_for_closure) {
			msgList.push('<li>Ensure case is marked as <strong>"Marked for closure"</strong></li>');
		}
		let len = this.followUpBillsData.length;
		for (let i = 0; i < len; i++) {
			if (!this.followUpBillsData[i].files.length || !this.followUpBillsData[i].gpay_files.length || !this.followUpBillsData[i].is_paid) {
				msgList.push("<li>Ensure Billing is completed for all followups</li>");
				break;
			}
		}
		return msgList;
	}

	readyToBillChange() {
		if (this.ready_to_bill) {
			let msgList = this.validateForReadyToBill();
			if (msgList.length) {
				let str = '<p class="mb-0">To proceed and mark this case as <strong>"Ready to Bill"</strong>, please ensure the following actions are completed</p>';
				str += "<ol>"
				str += msgList.join("");
				str += "</ol>"
				Swal.fire({
					title: 'Incomplete details',
					html: str,
					icon: 'warning',
					customClass: { htmlContainer: "text-start" }
				});
				setTimeout(() => {
					this.ready_to_bill = false;
				}, 0);
				return;
			}
			$("#billingQuestionsModal").modal("show");
		} else {
			let data = {
				id: this.uId,
				ready_to_bill: this.ready_to_bill,
				candidate_no_dues: 0,
				vendor_no_dues: 0
			}
			this.ready_to_bill_loader = true;
			this.apiService.updateCaseDetails(data).subscribe({
				next: (data: any) => {
					this.ready_to_bill_loader = false;
					this.toastr.success('Updated successfully', 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					this.getCaseDetails();
				}, error: (error) => {
					this.ready_to_bill_loader = false;
					this.toastr.error('Something went wrong', 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				},
			});
		}
	}

	autoReadyToBillLoader = false;
	autoReadyToBill() {
		return;
		if (!this.autoReadyToBillLoader) {
			let msgList = this.validateForReadyToBill();
			let ready_to_bill = true;
			if (msgList.length) {
				ready_to_bill = false;
			}
			if (ready_to_bill && !this.ready_to_bill) {
				let data = {
					id: this.uId,
					ready_to_bill: ready_to_bill
				}
				this.autoReadyToBillLoader = true;
				setTimeout(() => {
					this.apiService.updateCaseDetails(data).subscribe({
						next: (data: any) => {
							this.ready_to_bill = ready_to_bill;
							this.autoReadyToBillLoader = false;
							this.zone.run(() => { });
						}, error: (error) => {
							this.autoReadyToBillLoader = false;
						}
					});
				}, 500);
			}
		}
	}

	autoMarkForClosureLoader = false;
	autoMarkForClosure() {
		/* return; */
		if (!this.autoMarkForClosureLoader && this.caseDetails && this.followupList.length && this.caseReminder) {
			let msgList = this.validateForMarkForClosure();
			let mark_for_closure = true;
			if (msgList.length) {
				mark_for_closure = false;
			}
			if (mark_for_closure != this.mark_for_closure/* mark_for_closure && !this.mark_for_closure */) {
				let data = {
					id: this.uId,
					mark_for_closure: mark_for_closure
				}
				this.autoMarkForClosureLoader = true;
				setTimeout(() => {
					this.apiService.updateCaseDetails(data).subscribe({
						next: (data: any) => {
							this.mark_for_closure = mark_for_closure;
							this.autoMarkForClosureLoader = false;
							this.zone.run(() => { });
						}, error: (error) => {
							this.autoMarkForClosureLoader = false;
						}
					});
				}, 500);
			}
		}
	}

	saveBillQuestions() {
		if (!this.candidate_no_dues || !this.vendor_no_dues) {
			this.toastr.error('Cannot proceed if answer is "No"', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let data = {
			id: this.uId,
			ready_to_bill: this.ready_to_bill,
			candidate_no_dues: this.candidate_no_dues,
			vendor_no_dues: this.vendor_no_dues,
		}
		this.updateLoader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.updateLoader = false;
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getCaseDetails();
				$("#billingQuestionsModal").modal("hide");
			}, error: (error) => {
				this.updateLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	cancelBillQuestions() {
		setTimeout(() => {
			this.ready_to_bill = false;
		}, 0);
	}

	allVisitTypeApi() {
		this.apiService.allVisitTypeApi().subscribe({
			next: (data: any) => {
				this.allVisitType = data.data;
			}, error: (error) => {
				this.allVisitType = [];
			},
		});
	}

	openNewFollowupModal(visit_type_id: any = null) {
		this.f2.new_follow_up_date.setValue(null);
		this.f2.new_visit_type_id.setValue(visit_type_id);
		$("#newFollowupModalCasePage").modal("show");
	}

	getPrevFollowupDate() {
		let prevFollowupDate = null;
		if (this.followupList.length) {
			prevFollowupDate = this.followupList[0].follow_up_date;
		}
		return prevFollowupDate;
	}

	createNewFollowup() {
		this.flwupFormSubmitted = true;
		this.clearCustomErrorNewFlwup();
		if (this.newFollowupForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (
			isBefore(this.f2.new_follow_up_date.value, this.apiService.getDateFromDateString(this.caseDetails.start_date))
		) {
			this.f2.new_follow_up_date.setErrors({ incorrect: true });
			this.customErrorNewFlwup.new_follow_up_date = "Cannot be less than case start date";
			this.toastr.info("Followup date cannot be less than case start date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (
			this.getPrevFollowupDate() && isBefore(this.f2.new_follow_up_date.value, this.apiService.getDateFromDateString(this.getPrevFollowupDate()))
		) {
			this.f2.new_follow_up_date.setErrors({ incorrect: true });
			this.customErrorNewFlwup.new_follow_up_date = "Cannot be less than previous followup date";
			this.toastr.info("Followup date cannot be less than previous followup date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		/* if (
			isBefore(this.f2.new_follow_up_date.value, this.follow_up_date_original)
		) {
			this.f2.new_follow_up_date.setErrors({ incorrect: true });
			this.customErrorNewFlwup.new_follow_up_date = "Cannot be less than current followup date";
			return;
		} */
		let visit_type = this.f2.new_visit_type_id?.value;
		let is_payment_needed = false;
		if (visit_type == 1) {
			/* OPD */
			is_payment_needed = true;
		} else if (visit_type == 3) {
			/* Physiotherapy */
			is_payment_needed = true;
		} else if (visit_type == 4) {
			/* Tele-Consult */
			is_payment_needed = true;
		}
		let payload: any = {
			case_id_id: this.caseDetails.id,
			follow_up_date: this.apiService.getDateStringFromDate(this.f2.new_follow_up_date?.value),
			visit_type_id: this.f2.new_visit_type_id?.value,
			is_payment_needed: is_payment_needed
		}
		this.newFollowupLoader = true;
		this.apiService.createUpdateFollowup(payload).subscribe({
			next: (data: any) => {
				this.newFollowupLoader = false;
				this.toastr.success('Saved successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				$("#newFollowupModalCasePage").modal("hide");
				this.getFollowup();
			}, error: (error) => {
				this.newFollowupLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	showErrorNewFlwup(field: string) {
		if (this.f2[field].invalid && (this.flwupFormSubmitted || this.f2[field].touched || this.f2[field].dirty)) {
			return true;
		}
		return false;
	}

	clearCustomErrorNewFlwup() {
		Object.keys(this.f2).forEach(key => {
			if (this.f2[key].hasError('incorrect')) {
				try {
					delete this.f2[key].errors?.incorrect;
					this.f2[key].updateValueAndValidity();
				} catch (error) {
				}
			}
		});
		this.customErrorNewFlwup = {};
	}

	showTeleConLoader = false;
	createTeleConFUs(e: any) {
		try {
			e.stopPropagation();
		} catch (error) { }
		Swal.fire({
			title: 'Please confirm',
			html: 'Create Tele-Consult follow-ups for all OPD, IPD, Physiotherapy follow-ups?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Create'
		}).then((result) => {
			if (result.value) {
				this.showTeleConLoader = true;
				this.apiService.createTeleconFollowUps({ case_id: this.caseDetails.id }).subscribe({
					next: (response: any) => {
						this.showTeleConLoader = false;
						this.toastr.success('Tele-Consult follow-ups created successfully', 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}, error: (error) => {
						this.showTeleConLoader = false;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	selectedFollowupForFile: any = null;
	follFilesLoader = false;
	followupFilesForEdit: any[] = [];
	openFileModal() {
		this.followupFilesForEdit = [];
		this.selectedFollowupForFile = null;
		$("#followUpListForMailFileModal").modal("show");
	}

	getFollowUpFiles() {
		this.follFilesLoader = true;
		this.apiService.getFollowUpFiles({ id: this.selectedFollowupForFile }).subscribe({
			next: (data: any) => {
				data.data.map((bill: any) => {
					bill.file_url = bill.file_url === null ? [] : bill.file_url;
					return bill;
				});
				this.follFilesLoader = false;
				this.followupFilesForEdit = data.data;
			}, error: (error) => {
				this.follFilesLoader = false;
				this.followupFilesForEdit = [];
			}
		})
	}

	allowedFiles = allowedFiles;
	followUpFileUploaded(data: any, index: number) {
		if (!this.followupFilesForEdit[index].file_url) {
			this.followupFilesForEdit[index].file_url = [];
		}
		this.followupFilesForEdit[index].file_url.push(data);
	}

	deleteFollowupFile_1(name: string, i: number, j: number) {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.followupFilesForEdit[i].file_url.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	closeFileModal() {
		$("#followUpListForMailFileModal").modal("hide");
	}

	saveFileLoader = false;
	saveFiles_1() {
		let files: any[] = [];
		let len = this.followupFilesForEdit.length;
		for (let i = 0; i < len; i++) {
			let bill = this.followupFilesForEdit[i];
			if (!bill.file_name) {
				this.toastr.error("Please enter notes", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			files.push({
				"id": bill.id || "",
				"followup_id": this.selectedFollowupForFile,
				"file_name": bill.file_name,
				"file_url": bill.file_url,
			})
		};
		this.saveFileLoader = true;
		this.apiService.saveFollowUpFiles(files).subscribe({
			next: (data: any) => {
				this.saveFileLoader = false;
				this.toastr.success("Files saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.closeFileModal();
				this.apiService.sendFollowUpFilesRefreshEvent();
			}, error: (error: any) => {
				this.saveFileLoader = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	addFiles() {
		this.followupFilesForEdit.push({
			"id": "",
			"followup_id": this.selectedFollowupForFile,
			"file_name": null,
			"file_url": []
		});
	}

	removeFileDetails(index: number) {
		if (this.followupFilesForEdit[index].id) {
			Swal.fire({
				title: 'Warning',
				text: 'Are you sure you want to delete record?',
				icon: 'warning',
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#f23022'
			}).then((result) => {
				if (result.value) {
					this.apiService.deleteFollowUpFiles({ id: this.followupFilesForEdit[index].enc_id }).subscribe({
						next: data => {
							Swal.fire('Success', 'Record Deleted Successfully.', 'success');
							this.followupFilesForEdit.splice(index, 1);
							this.getFollowUpFiles();
						}, error: (error) => {
							if (error.status == 401) { return }
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					});
				}
			})
		} else {
			this.followupFilesForEdit.splice(index, 1);
		}
	}

	questionnaire: any[] = [];
	questionError: any = null;
	loadingQuestionnaire = false;
	savingQuestionnaire: any = null;
	currentQueFollIndex = 0;
	getQuestions() {
		this.loadingQuestionnaire = true;
		this.questionError = null;
		this.apiService.getAllCaseQuestions(atob(this.uId)).subscribe({
			next: (data: any) => {
				this.loadingQuestionnaire = false;
				try {
					this.questionnaire = data.map((d: any) => {
						d.questions.map((que: any) => {
							return {
								question: que.question,
								answer: que.answer || null,
								options: que.options
							}
						})
						return d;
					})
				} catch (error) {
					this.questionnaire = [];
				}
				/* if (data.Icd_codes && data.Icd_codes.length && data.Icd_codes[0].ICD_Code) {
					this.confirmIcdCode(data.Icd_codes[0].ICD_Code);
				} */
			}, error: (error) => {
				this.loadingQuestionnaire = false;
				this.questionnaire = [];
				if (error.status == 400) {
					this.questionError = error.error;
				} else {
					this.toastr.error('Something went wrong', 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}

	confirmIcdCode(ICD_Code: any) {
		Swal.fire({
			title: 'ICD code was found',
			html: 'ICD code <strong>' + ICD_Code + '</strong> was found. Would you like to save it?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		}).then((result) => {
			if (result.value) {
				const payload = {
					"id": this.uId,
					"icd_code": ICD_Code
				};
				this.apiService.updateCaseDetails(payload).subscribe({
					next: (data: any) => {
						this.toastr.success('Saved successfully', 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.caseDetails.icd_code = ICD_Code;
					}, error: (error) => {
						this.toastr.error('Something went wrong', 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	nextFollQue() {
		if (this.questionnaire.length > this.currentQueFollIndex + 1) {
			this.currentQueFollIndex++;
		}
	}

	prevFollQue() {
		if (this.currentQueFollIndex) {
			this.currentQueFollIndex--;
		}
	}

	removeQuestion(i: number, j: number) {
		this.questionnaire[i].questions.splice(j, 1);
	}

	saveQuestions(i: number) {
		let questions = this.questionnaire[i].questions.map((que: any) => {
			return {
				question: que.question,
				answer: que.answer || null,
				options: que.options
			}
		});
		let payload = {
			id: this.questionnaire[i].id,
			questions: questions
		}
		this.savingQuestionnaire = this.questionnaire[i].id;
		this.apiService.saveFollowupQuestions(payload).subscribe({
			next: (data: any) => {
				this.savingQuestionnaire = null;
				this.toastr.success('Saved successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getQuestions();
			}, error: (error) => {
				this.savingQuestionnaire = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	openBackgroundModal() {
		$("#backgroundModal").modal("show");
	}

	setBackgroundProperty(prop: string, virtualBackgroundEnabled: string) {
		this.backgroundProp = prop;
		this.virtualBackgroundEnabled = virtualBackgroundEnabled;
		this.setBackground();
		$("#backgroundModal").modal("hide");
	}

	async getProcessorInstance() {
		try {
			this.localVideoStream.unpipe();
			this.processor.unpipe();
			this.processor = null;
		} catch (error) { }
		if (!this.processor && this.localVideoStream) {
			this.processor = this.extension.createProcessor();
			try {
				await this.processor.init("./assets/wasms");
			} catch (e) {
				return null;
			}
			this.localVideoStream.pipe(this.processor).pipe(this.localVideoStream.processorDestination);
		}
		return this.processor;
	}

	setBackground() {
		if (this.virtualBackgroundEnabled == "color") {
			this.setBackgroundColor();
		} else if (this.virtualBackgroundEnabled == "blur") {
			this.setBackgroundBlurring();
		} else if (this.virtualBackgroundEnabled == "img") {
			this.setBackgroundImage();
		} else if (this.virtualBackgroundEnabled == "") {
			this.clearBackground();
		}
	}

	clearBackground() {
		try {
			this.localVideoStream.unpipe();
			this.processor.unpipe();
			this.processor = null;
		} catch (error) { }
	}

	async setBackgroundColor() {
		if (this.localVideoStream) {
			await this.getProcessorInstance();
			try {
				this.processor.setOptions({ type: 'color', color: this.backgroundProp });
				await this.processor.enable();
			} finally { }
			this.virtualBackgroundEnabled = "color";
		}
	}

	async setBackgroundBlurring() {
		if (this.localVideoStream) {
			await this.getProcessorInstance();
			try {
				this.processor.setOptions({ type: 'blur', blurDegree: 3 });
				await this.processor.enable();
			} finally { }
			this.virtualBackgroundEnabled = "blur";
		}
	}

	async setBackgroundImage() {
		const imgElement = document.createElement('img');
		imgElement.onload = async () => {
			await this.getProcessorInstance();
			try {
				this.processor.setOptions({ type: 'img', source: imgElement });
				await this.processor.enable();
			} finally { }

			this.virtualBackgroundEnabled = "img";
		}
		imgElement.src = this.backgroundProp;
	}

	getDevices() {
		AgoraRTC.getDevices(false).then(devices => {
			for (let i = 0; i < devices.length; i++) {
				if (devices[i].kind == "audioinput") {
					this.audioDevices.push(devices[i]);
				} else if (devices[i].kind == "videoinput") {
					this.videoDevices.push(devices[i]);
				}
			}
			this.selectedMicrophoneId = this.audioDevices[0].deviceId;
			this.selectedCameraId = this.videoDevices[0].deviceId;
		}).catch(e => {
			this.toastr.error("Unable to access microphone/camera.", 'Error', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			});
		});
	}

	stopTestCamera() {
		if (this.localVideoStream) {
			this.localVideoStream.stop();
			this.localVideoStream.close();
		}
		if (this.localAudioStream) {
			this.localAudioStream.stop();
			this.localAudioStream.close();
		}
		clearInterval(this.intervalMicListen);
		this.numberOfPidsToColor = 0;
	}

	testSpeaker() {
		this.playAlertRing.play();
	}

	/* getUnreadMsgCountOld() {
		const chatCollection = collection(this.firestore, this.chatCollectionName);
		const chatQuery = query(
			chatCollection,
			where('channel', '==', this.channelName),
			where('from', '==', this.candidateUserName),
			where('is_read', '!=', true)
		);
		return collectionData(chatQuery, { idField: 'id' }).pipe(
			map(msgs => msgs.length)
		);
	} */

	getUnreadMsgCount() {
		const chatCollection = collection(this.firestore, this.chatCollectionName);
		const chatQuery = query(
			chatCollection,
			where('channel', '==', this.channelName),
			/* where('from', '==', this.candidateUserName) */
			where('sender_type', '==', "candidate")
		);

		return collectionData(chatQuery, { idField: 'id' }).pipe(
			map((msgs: any[]) => {
				const unreadMsgs = msgs.filter(msg => {
					const readBy = msg['read_by'] || [];
					return !readBy.includes(this.user.id);
				});
				return unreadMsgs.length;
			})
		);
	}

	initializingChat = false;
	chatRoomId: any = null;
	setupVars() {
		this.initializingChat = true;
		/* AgoraRTC.registerExtensions([this.extension]);
		this.getDevices(); */
		this.messagingService.login().then(userCredential => {
			this.getChatMessages();
			/* this.loadLatestMessages(); */
			this.openChatPopup();
			this.initializingChat = false;
		}).catch(error => {
			this.initializingChat = false;
			this.toastr.error("Something went wrong", 'Error', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			});
		});
	}

	/* getChatMessagesOld() {
		const chatCollection = collection(this.firestore, this.chatCollectionName);
		const chatQuery = query(
			chatCollection,
			where('channel', '==', this.channelName),
			orderBy('msgTime', 'asc')
		);
		this.messagesSub = collectionData(chatQuery, { idField: 'id' }).subscribe((msgs: any[]) => {
			this.allMessages = msgs.map(msg => ({
				...msg,
				msgTime: msg.msgTime.toDate ? msg.msgTime.toDate() : msg.msgTime
			}));
			if (this.allMessages.length) {
				const latestMsg = this.allMessages[this.allMessages.length - 1];
				if (latestMsg.from == this.candidateUserName && latestMsg.is_read == false) {
					this.newMsgNotification();
				}
				if (this.isChatOpen) {
					for (let i = 0; i < this.allMessages.length; i++) {
						if (this.allMessages[i].from == this.candidateUserName && this.allMessages[i].is_read == false) {
							const msgId = this.allMessages[i].id;
							const msgRef = doc(this.firestore, `${this.chatCollectionName}/${msgId}`);
							updateDoc(msgRef, {
								is_read: true
							}).then(() => { }).catch(err => { });
						}
					}
				}
			}
			this.applyChatSearch(true);
		});
	} */

	getChatMessages() {
		const chatCollection = collection(this.firestore, this.chatCollectionName);
		const chatQuery = query(
			chatCollection,
			where('channel', '==', this.channelName),
			orderBy('msgTime', 'asc')
		);
		onSnapshot(chatQuery, snapshot => {
			this.allMessages = snapshot.docs.map(d => ({
				id: d.id,
				from_name: this.getUserNameByChatUsername(d.data()['from']),
				time_string: this.formatTimestamp(d.data()['msgTime']),
				validURL: this.validURL(d.data()['message']),
				...d.data()
			}));
			this.markMsgAsRead(true);
		});
	}

	changeChatBoxHeight(num: number) {
		/* try {
			const viewport = this.viewports.find(v =>
				v.elementRef.nativeElement.dataset.id === 'chatscroll'
			);
			if (viewport) {
				viewport.elementRef.nativeElement.style.height = num + '%';
			}
		} catch (error) { } */
		$("#chat-section-container").height(num + "%");
	}

	lastVisibleDoc: any = null;
	pageSize = 50;
	hasOlderMessages = true;
	loadLatestMessages() {
		const q = query(
			collection(this.firestore, this.chatCollectionName),
			where('channel', '==', this.channelName),
			orderBy('msgTime', 'desc'),
			limit(this.pageSize)
		);
		onSnapshot(q, snapshot => {
			this.processMessages(snapshot);
			this.hasOlderMessages = snapshot.docs.length === this.pageSize;
			this.markMsgAsRead(true);
		});
	}

	/* loadingOlderMsgs = false;
	async loadOlderMessages() {
		if (!this.lastVisibleDoc && this.loadingOlderMsgs) {
			return;
		}
		this.loadingOlderMsgs = true;
		const q = query(
			collection(this.firestore, this.chatCollectionName),
			where('channel', '==', this.channelName),
			orderBy('msgTime', 'desc'),
			startAfter(this.lastVisibleDoc),
			limit(this.pageSize)
		);
		const snapshot = await getDocs(q);
		if (!snapshot.empty) {
			this.processMessages(snapshot);
			if (snapshot.docs.length < this.pageSize) {
				this.hasOlderMessages = false;
			}
			this.markMsgAsRead(false);
		}
		this.loadingOlderMsgs = false;
	} */

	processMessages(snapshot: QuerySnapshot<DocumentData, DocumentData>) {
		const docs = snapshot.docs.map(d => ({
			id: d.id,
			from_name: this.getUserNameByChatUsername(d.data()["from"]),
			time_string: this.formatTimestamp(d.data()["msgTime"]),
			validURL: this.validURL(d.data()["message"]),
			...d.data()
		}));
		this.lastVisibleDoc = snapshot.docs[snapshot.docs.length - 1];
		this.allMessages = [...docs.reverse(), ...this.allMessages];
		return docs;
	}

	async markMsgAsRead(scroll = true) {
		if (this.allMessages.length) {
			const latestMsg = this.allMessages[this.allMessages.length - 1];
			const readBy = latestMsg['read_by'] || [];
			let isUnread = false;
			if (!readBy.includes(this.user.id)) {
				isUnread = true;
			}
			if (latestMsg.from == this.candidateUserName && isUnread/* !latestMsg.is_read */ && !latestMsg.is_call) {
				this.newMsgNotification();
			}
			if (this.isChatOpen) {
				/* for (let i = 0; i < this.allMessages.length; i++) {
					if (this.allMessages[i].from == this.candidateUserName &&  !this.allMessages[i].is_read) {
						const msgId = this.allMessages[i].id;
						const msgRef = doc(this.firestore, `${this.chatCollectionName}/${msgId}`);
						updateDoc(msgRef, {
							is_read: true
						}).then(() => {
						}).catch(err => {
						});
					}
				} */
				try {
					const messagesRef = collection(this.firestore, this.chatCollectionName);
					const q = query(
						messagesRef,
						where("sender_type", "==", "candidate"),
						where('channel', '==', this.channelName),

						/* where("is_read", "==", false), */

						/* where("from", "==", this.candidateUserName), */
						/* where("is_call", "==", false) */
					);
					const querySnapshot = await getDocs(q);
					const batch = writeBatch(this.firestore);
					let hasChanges = false;
					querySnapshot.forEach((docSnap) => {
						const data = docSnap.data();
						const readBy = data['read_by'] || [];
						if (!readBy.includes(this.user.id)) {
							batch.update(docSnap.ref, {
								read_by: arrayUnion(this.user.id),
								is_read: true
							});
							hasChanges = true;
						}
						/* batch.update(docSnap.ref, {
							is_read: true
						}); */
					});
					if (hasChanges) {
						await batch.commit();
						console.log("Messages marked as read for user:", this.user.id);
					}
					/* await batch.commit(); */
					console.log("All messages marked as read");
				} catch (err) {
					console.log(err);
				}
			}
		}
		this.applyChatSearch(scroll);
	}

	trackByMsgId(index: number, msg: any) {
		return msg.id;
	}

	formatTimestamp(ts: any): string {
		if (!ts) {
			return '';
		}
		let date: any;
		if (ts.toDate) {
			date = ts.toDate();
		} else {
			date = ts;
		}
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		return `${year}-${month}-${day} ${hours}:${minutes}`;
	}

	applyChatSearch(scroll = true) {
		let term: any = this.msgSearchControl.value;
		if (!term) {
			this.messages = this.allMessages.filter(msg => true);
		} else {
			term = term.toLowerCase();
			this.messages = this.allMessages.filter(msg => {
				try {
					const text = msg.message || msg.file_url;
					return text.toLowerCase().includes(term) || msg.from_name.toLowerCase().includes(term);
				} catch (error) {
					return true;
				}
			});
		}
		if (scroll) {
			this.scrollChatToBottom();
		}
	}

	clearChatSearch() {
		this.msgSearchControl.setValue(null);
	}

	scrollChatToBottom() {
		setTimeout(() => {
			let selector = "#messages-container";
			$(selector).animate({
				scrollTop: $(selector)[0].scrollHeight
			}, 'fast');
		}, 500);
		/* const viewport = this.viewports.find(v =>
			v.elementRef.nativeElement.dataset.id === 'chatscroll'
		);
		if (!viewport || !this.messages.length) {
			return;
		}
		setTimeout(() => {
			viewport.checkViewportSize();
			viewport.scrollToIndex(
				this.messages.length - 1,
				'instant'
			);
		}, 500); */
	}

	async deleteChat() {
		const q = query(
			collection(this.firestore, this.chatCollectionName),
			where('channel', '==', this.channelName),
			orderBy('msgTime', 'asc')
		);
		const snapshot = await getDocs(q);
		snapshot.forEach(docSnap => deleteDoc(docSnap.ref).then(() => {
			console.log("Deleted");
		}).catch(err => {
			console.log("Delete error", err);
		}));
	}

	newMsgNotification() {
		this.playAlertNotify.play();
	}

	openForm(e: any = null) {
		try {
			e.stopPropagation();
		} catch (error) { }
		this.setupVars();
		/* if (this.messagesSub) {
			this.openChatPopup();
		} else {
			this.setupVars();
		} */
	};

	isChatOpen = false;
	async openChatPopup() {
		$("#videoCallPopup").removeClass("hide-video-call");
		this.isChatOpen = true;
		/* for (let i = 0; i < this.allMessages.length; i++) {
			if (this.allMessages[i].from == this.candidateUserName && !this.allMessages[i].is_read) {
				const msgId = this.allMessages[i].id;
				const msgRef = doc(this.firestore, `${this.chatCollectionName}/${msgId}`);
				updateDoc(msgRef, {
					is_read: true
				}).then(() => {
				}).catch(err => {
				});
			}
		} */
		try {
			const messagesRef = collection(this.firestore, this.chatCollectionName);
			const q = query(
				messagesRef,
				where("sender_type", "==", "candidate"),
				where('channel', '==', this.channelName),

				/* where("is_read", "==", false), */

				/* where("from", "==", this.candidateUserName), */
				/* where("is_call", "==", false) */
			);
			const querySnapshot = await getDocs(q);
			const batch = writeBatch(this.firestore);
			let hasChanges = false;
			querySnapshot.forEach((docSnap) => {
				const data = docSnap.data();
				const readBy = data['read_by'] || [];

				// If the current user hasn't marked this message as read yet
				if (!readBy.includes(this.user.id)) {
					batch.update(docSnap.ref, {
						read_by: arrayUnion(this.user.id),
						is_read: true
					});
					hasChanges = true;
				}
				/* batch.update(docSnap.ref, {
					is_read: true
				}); */
			});
			if (hasChanges) {
				await batch.commit();
				console.log("Messages marked as read for user:", this.user.id);
			}
			console.log("All messages marked as read");
		} catch (err) {
			console.log(err);
		}
	}

	closeForm() {
		$("#videoCallPopup").addClass("hide-video-call");
		this.isChatOpen = false;
	}

	sendMsg() {
		if (!this.msg || !this.msg.trim()) {
			return;
		}
		this.sendMessage(null, this.msg);
		this.msg = null;
	}

	fileUrlToSend!: string;
	assignFileToSend(fileUrl: string) {
		this.fileUrlToSend = fileUrl;
		this.openFileMang();
	}

	@ViewChild('fileUploadComp') fileUploadComp!: FileUploadComponent;

	isDraggingOver = false;

	/* @HostListener('dragenter', ['$event'])
	onDragEnter(event: DragEvent) {
		if (!this.isChatOpen) return;
		event.preventDefault();
		event.stopPropagation();
		this.isDraggingOver = true;
	}

	@HostListener('dragover', ['$event'])
	onDragOver(event: DragEvent) {
		if (!this.isChatOpen) return;
		event.preventDefault();
		event.stopPropagation();
		this.isDraggingOver = true;
	}

	@HostListener('dragleave', ['$event'])
	onDragLeave(event: DragEvent) {
		if (!this.isChatOpen) return;
		event.preventDefault();
		event.stopPropagation();
		this.isDraggingOver = false;
	}

	@HostListener('drop', ['$event'])
	onDrop(event: DragEvent) {
		if (!this.isChatOpen) return;
		event.preventDefault();
		event.stopPropagation();
		this.isDraggingOver = false;

		const files = event.dataTransfer?.files;
		if (files && files.length > 0) {
			const droppedFile = files[0];

			const mockDropEntry: NgxFileDropEntry = {
				relativePath: droppedFile.name,
				fileEntry: {
					name: droppedFile.name,
					isDirectory: false,
					isFile: true,
					file: (callback: (file: File) => void) => {
						callback(droppedFile);
					}
				} as any
			};

			setTimeout(() => {
				if (this.fileUploadComp) {
					this.fileUploadComp.onFileSelect([mockDropEntry]);
				} else {
					this.toastr.error("Unable to upload", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}, 300);
		}
	} */

	onDragEnter(event: DragEvent) {
		if (!this.isChatOpen) return;
		event.preventDefault();
		event.stopPropagation();
		this.isDraggingOver = true;
	}

	onDragOver(event: DragEvent) {
		if (!this.isChatOpen) return;
		event.preventDefault();
		event.stopPropagation();
		this.isDraggingOver = true;
	}

	onDragLeave(event: DragEvent) {
		if (!this.isChatOpen) return;
		event.preventDefault();
		event.stopPropagation();
		const target = event.currentTarget as HTMLElement;
		const related = event.relatedTarget as HTMLElement;
		if (target && related && target.contains(related)) {
			return;
		}
		this.isDraggingOver = false;
	}

	onDrop(event: DragEvent) {
		if (!this.isChatOpen) return;
		event.preventDefault();
		event.stopPropagation();
		this.isDraggingOver = false;

		const files = event.dataTransfer?.files;
		if (files && files.length > 0) {
			const droppedFile = files[0];

			const mockDropEntry: NgxFileDropEntry = {
				relativePath: droppedFile.name,
				fileEntry: {
					name: droppedFile.name,
					isDirectory: false,
					isFile: true,
					file: (callback: (file: File) => void) => {
						callback(droppedFile);
					}
				} as any
			};

			setTimeout(() => {
				if (this.fileUploadComp) {
					this.fileUploadComp.onFileSelect([mockDropEntry]);
				} else {
					this.toastr.error("Unable to upload", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}, 300);
		}
	}

	sendFile(fileUrl: string) {
		if (!fileUrl || !fileUrl.trim()) {
			return;
		}
		this.fileUploaderLoader = true;
		this.sendMessage(fileUrl, null);
	}

	sendMessage(fileUrl: string | null, msg: string | null) {
		let msgObj = {
			channel: this.channelName,
			file_url: fileUrl,
			message: msg,
			/* msgTime: new Date(), */
			msgTime: Timestamp.now(),
			from: this.userName,
			sender_type: "doctor",
			/* from_name: this.getUserNameByChatUsername(this.userName), */
			is_read: false,
			is_call: false
		};
		this.messagingService.addEntryToFirebase(msgObj, this.chatCollectionName).then((done) => {
			if (!this.remoteCalls.length) {
				this.beforeSendNotification(3);
			}
			if (fileUrl) {
				this.chatFileUploaded(fileUrl);
			}
			/* setTimeout(() => {
				this.apiService.setViewportData1(true);
			}, 100); */
		}).catch((err) => {
			this.toastr.error("Unable to send", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		});
		/* this.chatService.sendMessage(this.chatRoomId, this.msg);
		this.msg = ''; */
	}

	private currentCallDocRef: any = null;
	private remoteUserJoined: boolean = false;
	private callTimeoutTimer: any = null;
	private isCallInProgress: boolean = false;
	outgoingCallWaitingperiod: number = 60000;
	waitingTimeString: string = '';
	private callCountdownTimer: any = null;

	async addOutgoingCallEntryInMessage(type: string, call_status: string | null) {
		this.isCallInProgress = true;
		this.remoteUserJoined = false;
		let msgObj = {
			channel: this.channelName,
			file_url: null,
			call_status: call_status,
			message: type,
			/* msgTime: new Date(), */
			msgTime: Timestamp.now(),
			from: this.userName,
			sender_type: "doctor",
			/* from_name: this.getUserNameByChatUsername(this.userName), */
			is_read: false,
			is_call: true,
			call_duration: 0
		};
		try {
			// Wait for Firebase to create the document
			this.currentCallDocRef = await this.messagingService.addEntryToFirebase(msgObj, this.chatCollectionName);
			console.log("currentCallDocRef", this.currentCallDocRef);
			this.beforeSendNotification(type == "Video Call" ? 1 : 2);
		} catch (err) {
			console.error("Error adding call entry: ", err);
			this.isCallInProgress = false;
		}
		/* this.messagingService.addEntryToFirebase(msgObj, this.chatCollectionName).then((done) => { }).catch((err) => { }); */
	}

	private startCallTimeout() {
		let remainingTimeMs = this.outgoingCallWaitingperiod;
		this.updateWaitingDisplay(remainingTimeMs);

		// 1-second interval to update the visual countdown string
		this.callCountdownTimer = setInterval(() => {
			remainingTimeMs -= 1000;
			if (remainingTimeMs <= 0) {
				// FIX: Only clear the interval here, do NOT call clearWaitingTimers() 
				// which would wipe out the main timeout below!
				if (this.callCountdownTimer) {
					clearInterval(this.callCountdownTimer);
					this.callCountdownTimer = null;
				}
			} else {
				this.updateWaitingDisplay(remainingTimeMs);
			}
		}, 1000);

		// Timeout to handle the action after the waiting period ends
		this.callTimeoutTimer = setTimeout(async () => {
			// Clean up interval and text display safely
			if (this.callCountdownTimer) {
				clearInterval(this.callCountdownTimer);
				this.callCountdownTimer = null;
			}
			this.waitingTimeString = '';
			this.callTimeoutTimer = null;

			// If no one joined by the time the timer finishes:
			if (!this.remoteUserJoined) {
				if (this.currentCallDocRef) {
					try {
						/* await updateDoc(this.currentCallDocRef, { call_status: 'timeout' }); */
					} catch (error) {
						console.error("Error updating call status to timeout:", error);
					}
					// Clear the reference so leave() won't overwrite it with 'cancelled'
					this.currentCallDocRef = null;
				}

				// Force leave the channel automatically
				this.beforeSendNotification(4);
				this.leave();
			}
		}, this.outgoingCallWaitingperiod);
	}

	// Helper to format milliseconds into mm:ss
	private updateWaitingDisplay(ms: number) {
		const totalSeconds = Math.floor(ms / 1000);
		const minutes = Math.floor(totalSeconds / 60);
		const seconds = totalSeconds % 60;

		const formattedMinutes = minutes.toString().padStart(2, '0');
		const formattedSeconds = seconds.toString().padStart(2, '0');

		this.waitingTimeString = `Waiting for remote user: ${formattedMinutes}:${formattedSeconds}`;
	}

	// Helper to clear both the timeout and the countdown interval
	private clearWaitingTimers() {
		if (this.callTimeoutTimer) {
			clearTimeout(this.callTimeoutTimer);
			this.callTimeoutTimer = null;
		}
		if (this.callCountdownTimer) {
			clearInterval(this.callCountdownTimer);
			this.callCountdownTimer = null;
		}
		this.waitingTimeString = '';
	}

	// Call this inside your Agora SDK 'user-joined' event listener
	public handleRemoteUserJoined() {
		this.remoteUserJoined = true;
		this.clearWaitingTimers();
		this.stopRinging();
	}

	addCallEntryForNotificationHandling(action: string, type: string) {
		/* return; */
		let msgObj = {
			action: action,
			type: type,
			channel: this.channelName,
			timestamp: Timestamp.now(),
			from: "doctor"
		};
		this.messagingService.addEntryToFirebase(msgObj, this.callCollectionName).then((done) => { }).catch((err) => { });
	}

	addMessageFromCandidate() {
		/* For testing purpose */
		let msgObj = {
			channel: this.channelName,
			file_url: null,
			message: "Video Call",
			msgTime: Timestamp.now(),
			from: this.candidateUserName,
			sender_type: "candidate",
			is_read: false,
			is_call: true
		};
		this.messagingService.addEntryToFirebase(msgObj, this.chatCollectionName).then((done) => { }).catch((err) => { });
	}

	getDateString(date: any) {
		return this.apiService.getDateTimeStringFromDate(date);
	}

	beforeSendNotification(type: number) {
		if (type === 4/* disconnet */) {
			if (this.remoteCalls.length < 2) {
				this.sendNotification(type);
			}
		} else {
			this.checkForCandidateAndSendNotification(type);
		}
	}

	checkForCandidateAndSendNotification(type: number) {
		this.apiService.getUsersInChannel(this.channelName).subscribe({
			next: (data: any) => {
				let details = data.data;
				if (details.channel_exist && details.users) {
					let candidateCount = details.users.filter((u: any) => u == this.caseDetails.candidate).length;
					if (!candidateCount) {
						this.sendNotification(type);
					}
				} else {
					this.sendNotification(type);
				}
			}, error: (error: any) => { }
		})
	}

	sendNotification(type: number) {
		const payload = {
			id: this.caseDetails.candidate
		}
		switch (type) {
			case 1:
				payload["type"] = "videocall";
				break;
			case 2:
				payload["type"] = "audio";
				break;
			case 3:
				payload["type"] = "message";
				break;
			case 4:
				payload["type"] = "disconnet";
				break;
			default:
				payload["type"] = "message";
		}
		this.apiService.pushNotification(payload).subscribe({
			next: (data: any) => {
				if ((type === 1 || type == 2) && !this.remoteCalls.length) {
					this.startWaitTimer();
				}
			}, error: (error: any) => {
				if ((type === 1 || type == 2) && !this.remoteCalls.length) {
					this.startWaitTimer();
				}
			}
		});
	}

	async startWaitTimer() {
		// EDGE CASE FIX: If the user clicked 'leave' WHILE addDoc was still pending
		if (!this.isCallInProgress) {
			if (this.currentCallDocRef) {
				/* await updateDoc(this.currentCallDocRef, { call_status: 'cancelled' }); */
				this.currentCallDocRef = null;
			}
			return; // Stop here, do not start the timeout timer
		}

		// Start the timeout watcher normally
		this.startCallTimeout();
		this.startRinging();
	}

	fileUploaderLoader = false;
	is_payment_receipt: "Yes" | "No" | null = null;
	receipt_amount: any = null;
	chatFileUploaded(filepath: any) {
		const files = [
			{
				"id": "",
				"case_id_id": this.caseDetails.id,
				"file_name": this.getFileName(filepath),
				"is_chat": true,
				"is_payment_receipt": this.is_payment_receipt === "Yes",
				"amount": this.is_payment_receipt === "Yes" ? this.receipt_amount : null,
				"file_url": [filepath]
			}
		];
		this.fileUploaderLoader = true;
		this.apiService.saveFollowUpFiles(files).subscribe({
			next: (data: any) => {
				this.fileUploaderLoader = false;
				$("#chatFileModal").modal("hide");
			}, error: (error: any) => {
				this.fileUploaderLoader = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showChatFileUploader = false;
	isReceiptFormChanged() {
		if (!this.is_payment_receipt) {
			this.showChatFileUploader = false;
		} else if (this.is_payment_receipt === "Yes" && !this.receipt_amount) {
			this.showChatFileUploader = false;
		} else {
			this.showChatFileUploader = true;
		}
		/* if (this.is_payment_receipt !== "Yes") {
			this.receipt_amount = null;
		} */
	}

	openFileMang() {
		this.is_payment_receipt = null;
		this.receipt_amount = null;
		this.isReceiptFormChanged();
		$("#chatFileModal").modal("show");
	}

	joiningCall: number = 0;
	callType: string = "";
	initJoinCall(isVideoCall = true, initiatedByUser = true) {
		if (isVideoCall) {
			this.joiningCall = 1/* Video call */;
			this.callType = "video";
		} else {
			this.joiningCall = 2/* Audio call */;
			this.callType = "audio";
		}
		AgoraRTC.registerExtensions([this.extension]);
		AgoraRTC.getDevices(false).then(devices => {
			for (let i = 0; i < devices.length; i++) {
				if (devices[i].kind == "audioinput") {
					this.audioDevices.push(devices[i]);
				} else if (devices[i].kind == "videoinput") {
					this.videoDevices.push(devices[i]);
				}
			}
			this.selectedMicrophoneId = this.audioDevices[0].deviceId;
			this.selectedCameraId = this.videoDevices[0].deviceId;
			this.apiService.getAgoraToken(this.userId, this.channelName).subscribe({
				next: (res3: any) => {
					if (this.hasAnyUserVideo()) {
						this.changeChatBoxHeight(50);
					}
					/* if (this.callType == "video") {
						this.changeChatBoxHeight(50);
					} */
					this.assignClientHandlers();
					this.videoClient.join(environment.agoraAppID, this.channelName, res3["rtc_token"], this.userId).then((uId) => {
						this.localStreams.push(uId);
						if (isVideoCall) {
							AgoraRTC.createMicrophoneAndCameraTracks({ microphoneId: this.selectedMicrophoneId }, { cameraId: this.selectedCameraId }).then((tracks) => {
								$("#agora_local").html("");
								this.localVideoStream = tracks[1];
								this.localAudioStream = tracks[0];
								this.localVideoStream.play("agora_local");
								this.setBackground();
								this.publishTracks(tracks);
								if (!this.remoteCalls.length && this.chatAction != "video") {
									/* if (initiatedByUser) {
										this.beforeSendNotification(1);
									} */
									this.addCallEntryForNotificationHandling("connect", "video");
								}
								if (initiatedByUser) {
									this.addOutgoingCallEntryInMessage("Video Call", "dialing");
								}
							}, (error: any) => {
								this.joiningCall = 0;
								this.toastr.error("Unable to access microphone/camera.", 'Error', {
									tapToDismiss: true,
									closeButton: true,
									timeOut: 3000
								});
							});
						} else {
							AgoraRTC.createMicrophoneAudioTrack({ microphoneId: this.selectedMicrophoneId }).then((track) => {
								$("#agora_local").html("");
								this.localAudioStream = track;
								this.publishTracks(track);
								if (!this.remoteCalls.length && this.chatAction != "audio") {
									/* if (initiatedByUser) {
										this.beforeSendNotification(2);
									} */
									this.addCallEntryForNotificationHandling("connect", "audio");
								}
								if (initiatedByUser) {
									this.addOutgoingCallEntryInMessage("Audio Call", "dialing");
								}
							}, (error: any) => {
								this.joiningCall = 0;
								this.toastr.error("Unable to access microphone.", 'Error', {
									tapToDismiss: true,
									closeButton: true,
									timeOut: 3000
								});
							});
						}
					});
				}, error: (error) => {
					this.joiningCall = 0;
					this.toastr.error("Something went wrong", 'Error', {
						tapToDismiss: true,
						closeButton: true,
						timeOut: 3000
					});
				}
			});
		}).catch(e => {
			this.joiningCall = 0;
			this.toastr.error("Unable to access microphone/camera.", 'Error', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			});
		});
	}

	/* userIdForOnlineCheck!: number;
	checkRemoteOnline() {
		this.userIdForOnlineCheck = Math.floor(Math.random() * 9000) + 1000;
		this.apiService.getAgoraToken(this.userIdForOnlineCheck, this.channelName).subscribe({
			next: (res3: any) => {
				this.assignClientHandlersForOnlineCheck();
				this.videoClientForOnlineCheck.join(environment.agoraAppID, this.channelName, res3["rtc_token"], this.userIdForOnlineCheck).then((uId) => {
				}).catch((error) => {
					this.checkRemoteOnline();
				});
			}, error: (error) => {
				this.toastr.error("Something went wrong", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	} */

	channel_exist = false;
	checkRemoteOnlineNew() {
		timer(0, 5000).pipe(
			switchMap(() => this.apiService.getUsersInChannel(this.channelName).pipe(
				catchError(error => {
					console.error('Failed to fetch users in channel:', error);
					return of(null);
				})
			)),
			takeUntil(this.destroy$)
		).subscribe((data: any) => {
			this.channel_exist = data.data.channel_exist;
		});
	}

	recordingPayload: any;
	publishTracks(tracks: ILocalTrack | ILocalTrack[]) {
		this.videoClient.publish(tracks).then((success) => {
			this.joiningCall = 0;
			this.joinStatus.isJoined = true;
			this.apiService.sendCallJoinStatus(this.joinStatus.isJoined);
			this.apiService.startRecording(this.channelName).subscribe({
				next: (data: any) => {
					this.recordingPayload = data;
				}, error: (error) => { }
			});
		}, (error) => {
			this.joiningCall = 0;
			this.toastr.error("Something went wrong", 'Error', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			});
		});
	}

	/* async shareScreen() {
		if (this.screenClient != undefined && this.screenClient != null) {
			try {
				this.shareStream.stop();
				this.shareStream.close();
				await this.screenClient.leave();
			} catch (error) { }
			this.initShareScreen();
		} else {
			this.initShareScreen();
		}
	}

	initShareScreen() {
		this.apiService.getAgoraToken(this.screenUserId, this.channelName).subscribe({
			next: (data: any) => {
				this.screenClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
				this.screenClient.join(environment.agoraAppID, this.channelName, data["rtc_token"], this.screenUserId).then((uId) => {
					this.localStreams.push(uId);
					AgoraRTC.createScreenVideoTrack({ encoderConfig: "1080p_1" }, "disable").then((track) => {
						this.shareStream = track;
						this.screenClient.publish(track).then((success) => { }, (error) => {
							try {
								this.screenClient.leave();
							} catch (error) { }
							this.toastr.error("Unable to share screen.", 'Error', {
								tapToDismiss: true,
								closeButton: true,
								timeOut: 3000
							});
						});
					}, (error: any) => {
						try {
							this.screenClient.leave();
						} catch (error) { }
						this.toastr.error("Unable to share screen.", 'Error', {
							tapToDismiss: true,
							closeButton: true,
							timeOut: 3000
						});
					});
				});
			}, error: (error) => {
				this.toastr.error("Unable to share screen.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	} */

	assignClientHandlers(): void {
		this.videoClient.on("token-privilege-will-expire", (user: any) => {
			this.renewToken();
		});
		this.videoClient.on("token-privilege-did-expire", (user: any) => {
			this.renewToken();
		});
		this.videoClient.on("user-published", (user: IAgoraRTCRemoteUser, mediaType: any) => {
			var uid: any = user.uid;
			if (!this.localStreams.includes(uid)) {
				this.subscribeRemoteUser(user, mediaType);
				/* this.toastr.info("Remote user published:" + mediaType, 'Info', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				}); */
			}
		});
		this.videoClient.on("user-unpublished", (user: IAgoraRTCRemoteUser) => {
			var uid: any = user.uid;
			if (!user.videoTrack && !user.audioTrack) {
				this.remoteCalls = this.remoteCalls.filter(call => call.user.uid != uid);
				this.refreshRemoteVideos();
			} else if (!user.videoTrack) {
				$("#" + uid).css("background-color", "#000");
				for (let i = 0; i < this.remoteCalls.length; i++) {
					if (this.remoteCalls[i].user.uid == uid) {
						this.remoteCalls[i].user.hasVideo = false;
					}
				}
			}
			/* this.toastr.info("Remote user unpublished", 'Info', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			}); */
		});
		this.videoClient.on("user-left", (user: IAgoraRTCRemoteUser) => {
			var uid: any = user.uid;
			this.remoteCalls = this.remoteCalls.filter(call => call.user.uid != uid);
			this.refreshRemoteVideos();
		});
	}

	/* remoteUsersCount = 0; */
	/* assignClientHandlersForOnlineCheck(): void {
		this.videoClientForOnlineCheck.on("user-published", (user: IAgoraRTCRemoteUser, mediaType: any) => {
			this.getRemoteUsersCount();
		});
		this.videoClientForOnlineCheck.on("user-unpublished", (user: IAgoraRTCRemoteUser) => {
			this.getRemoteUsersCount();
		});
		this.videoClientForOnlineCheck.on("user-left", (user: IAgoraRTCRemoteUser) => {
			this.getRemoteUsersCount();
		});
	}

	getRemoteUsersCount() {
		this.remoteUsersCount = this.videoClientForOnlineCheck.remoteUsers.length;
	} */

	refreshRemoteVideos() {
		if (this.currentVideo) {
			try {
				let found = false;
				for (let i = 0; i < this.remoteCalls.length; i++) {
					if (this.remoteCalls[i].user.uid == this.currentVideo.user.uid) {
						this.currentVideo = this.remoteCalls[i];
						found = true;
					}
				}
				if (found) {
					setTimeout(() => {
						this.playMain();
					}, 1000);
				} else {
					this.currentVideo = null;
				}
			} catch (error) { }
		} else {
			this.currentVideo = null;
		}
		for (let i = 0; i < this.remoteCalls.length; i++) {
			if (this.showDiv(this.remoteCalls[i].user.uid)) {
				setTimeout(() => {
					this.remoteCalls[i].user.audioTrack?.play();
				}, 1000);
				setTimeout(() => {
					try {
						let divWidth = $("#" + this.remoteCalls[i].user.uid.toString()).width();
						let videoWidth = this.remoteCalls[i].user.videoTrack._videoWidth;
						let videoHeight = this.remoteCalls[i].user.videoTrack._videoHeight;
						let divHeight = videoHeight * divWidth / videoWidth;
						$("#" + this.remoteCalls[i].user.uid.toString()).height(divHeight);
					} catch (error) {
						console.log(error);
					}
					this.remoteCalls[i].user.videoTrack?.play(this.remoteCalls[i].user.uid.toString());
				}, 1000);
			}
		}
		/* for (let i = 0; i < this.remoteCalls.length; i++) {
			if (this.showDiv(this.remoteCalls[i].user.uid)) {
				setTimeout(() => {
					this.remoteCalls[i].user.audioTrack?.play();
				}, 1000);
				setTimeout(() => {
					this.remoteCalls[i].user.videoTrack?.play(this.remoteCalls[i].user.uid.toString());
				}, 1000);
			}
		} */
	}

	async subscribeRemoteUser(user: IAgoraRTCRemoteUser, mediaType: any) {
		console.log("Remote user:", user);
		await this.videoClient.subscribe(user, mediaType);
		this.handleRemoteUserJoined();
		let uid = user.uid;
		this.remoteCalls = this.remoteCalls.filter(call => call.user.uid != uid);
		/* if (uid == this.otherSideUserId.toString()) {
			this.remoteCalls.push({ uname: this.candName, user: user });
		} else if (uid == this.otherSideScreenUserId.toString()) {
			this.remoteCalls.push({ uname: this.candName + "_Screen", user: user });
		} else {
			this.remoteCalls.push({ uname: this.userName, user: user });
		} */
		if (uid != this.userId.toString() /* && uid != this.screenUserId.toString() */) {
			this.remoteCalls.push({ uname: uid, user: user });
		} else {
			/* this.remoteCalls.push({ uname: this.userName, user: user }); */
		}
		this.refreshRemoteVideos();
	}

	hasAnyUserVideo() {
		let anyVideo = false;
		for (let i = 0; i < this.remoteCalls.length; i++) {
			if (this.remoteCalls[i].user.hasVideo) {
				anyVideo = true;
			}
		}
		return anyVideo;
	}

	showVideoContainer() {
		if (this.joinStatus.isJoined && (this.hasAnyUserVideo() || (this.localVideoStream && !this.isVideoMute))) {
			return true;
		} else {
			return false;
		}
	}

	getWidth(id: any) {
		try {
			return ($("#" + id).width() || 350);
		} catch (error) {
			return 350;
		}
	}

	renewToken() {
		this.apiService.getAgoraToken(this.userId, this.channelName).subscribe({
			next: (data: any) => {
				this.videoClient.renewToken(data["rtc_token"]);
			}, error: (error) => {
				this.toastr.error("Unable to continue the call.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	async leave() {
		this.apiService.stopRecording(this.recordingPayload).subscribe({
			next: (data: any) => {
				this.recordingPayload = null;
			}, error: (error) => { }
		});
		this.isCallInProgress = false;
		this.clearWaitingTimers();
		this.stopRinging();
		if (!this.remoteUserJoined && this.currentCallDocRef) {
			try {
				/* await updateDoc(this.currentCallDocRef, { call_status: 'cancelled' }); */
				this.currentCallDocRef = null;
			} catch (error) {
				console.error("Error updating call status to cancelled:", error);
			}
		}
		this.remoteUserJoined = false;
		this.currentCallDocRef = null;
		try {
			this.localAudioStream.stop();
			this.localAudioStream.close();
		} catch (error) { }
		try {
			this.localVideoStream.stop();
			this.localVideoStream.close();
		} catch (error) { }
		this.joinStatus.isJoined = false;
		this.apiService.sendCallJoinStatus(this.joinStatus.isJoined);
		this.remoteCalls = [];
		if (this.videoClient != undefined) {
			await this.videoClient.leave();
			/* this.beforeSendNotification(4); */
		}
		if (this.screenClient != undefined) {
			try {
				this.shareStream.stop();
				this.shareStream.close();
			} catch (error) { }
			await this.screenClient.leave();
		}
		/* try {
			this.subs.forEach(s => s.unsubscribe());
			this.agora.leaveChannel();
			this.agora.logout();
		} catch (error) { } */
		this.isMute = false;
		this.isVideoMute = false;

		let url = this.router.url;
		try {
			url = decodeURIComponent(url);
		} catch (error) { }
		if (this.chatAction == "video") {
			this.router.navigate([url.replace("video", "no")]);
		} else if (this.chatAction == "audio") {
			this.router.navigate([url.replace("audio", "no")]);
		}
		this.addCallEntryForNotificationHandling("disconnect", this.callType);
		this.changeChatBoxHeight(75);
		this.callType = "";
	}

	toggleMute() {
		if (this.localAudioStream) {
			if (this.isMute) {
				this.localAudioStream.setMuted(false);
			} else {
				this.localAudioStream.setMuted(true);
			}
			this.isMute = !this.isMute;
		} else {
			if (!this.remoteCalls.length && this.chatAction != "audio") {
				this.beforeSendNotification(2);
				this.addCallEntryForNotificationHandling("connect", "audio");
			}
			AgoraRTC.createMicrophoneAudioTrack({ microphoneId: this.selectedMicrophoneId }).then((track) => {
				$("#agora_local").html("");
				this.localAudioStream = track;
				this.publishTracks(track);
			}, (error: any) => {
				this.joiningCall = 0;
				this.toastr.error("Unable to access microphone.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			});
		}
	}

	toggleMuteVideo() {
		if (this.localVideoStream) {
			if (this.isVideoMute) {
				this.setBackground();
				this.localVideoStream.setMuted(false);
				this.isVideoMute = false;
			} else {
				this.localVideoStream.setMuted(true);
				this.clearBackground();
				this.isVideoMute = true;
			}
		} else {
			AgoraRTC.createCameraVideoTrack({ cameraId: this.selectedCameraId }).then((track) => {
				$("#agora_local").html("");
				this.localVideoStream = track;
				this.localVideoStream.play("agora_local");
				this.setBackground();
				this.isVideoMute = false;
				this.publishTracks(track);
			}, (error: any) => {
				this.joiningCall = 0;
				this.toastr.error("Unable to access camera.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			});
		}
	}

	highlightStream(index: number) {
		$("#highlightedVideoPopup").removeClass("hide-video-call");
		this.currentVideo = null;
		this.currentVideo = this.remoteCalls[index];
		this.refreshRemoteVideos();
		/* for (let i = 0; i < this.remoteCalls.length; i++) {
			if (this.showDiv(this.remoteCalls[i].user.uid)) {
				setTimeout(() => {
					this.remoteCalls[i].user.audioTrack?.play();
				}, 1000);
				setTimeout(() => {
					this.remoteCalls[i].user.videoTrack?.play(this.remoteCalls[i].user.uid.toString());
				}, 1000);
			}
		}
		setTimeout(() => {
			this.playMain();
		}, 1000); */
	}

	playMain() {
		try {
			this.currentVideo.user.audioTrack?.play();
		} catch (error) { }
		try {
			/* try {
				let divWidth = $("#" + this.currentVideo.user.uid.toString()).width();
				let videoWidth = this.currentVideo.user.videoTrack._videoWidth;
				let videoHeight = this.currentVideo.user.videoTrack._videoHeight;
				let divHeight = videoHeight * divWidth / videoWidth;
				$("#" + this.currentVideo.user.uid.toString()).height(divHeight);
			} catch (error) { } */
			/* try {
				let $div = $("#" + this.currentVideo.user.uid.toString());
				let videoWidth = this.currentVideo.user.videoTrack._videoWidth;
				let videoHeight = this.currentVideo.user.videoTrack._videoHeight;
				let maxHeight = $div.parent().height() || window.innerHeight;
				if (videoHeight > videoWidth) {
					let divWidth = (videoWidth * maxHeight) / videoHeight;
					$div.width(divWidth);
					$div.height(maxHeight);
				} else {
					let divWidth = $div.parent().width();
					let divHeight = (videoHeight * divWidth) / videoWidth;
					$div.width('100%');
					$div.height(divHeight);
				}
			} catch (error) {
				console.log(error);
			} */
			try {
				let $videoDiv = $("#" + this.currentVideo.user.uid.toString());
				let $popup = $("#highlightedVideoPopup");

				let videoWidth = this.currentVideo.user.videoTrack._videoWidth;
				let videoHeight = this.currentVideo.user.videoTrack._videoHeight;
				let maxContainerHeight = $popup.height() - $popup.find('.bg-theme').outerHeight();
				if (videoHeight > videoWidth) {
					let calculatedWidth = (videoWidth * maxContainerHeight) / videoHeight;
					$videoDiv.css({ width: calculatedWidth + 'px', height: maxContainerHeight + 'px' });
					$popup.css('width', calculatedWidth + 'px');
				} else {
					let maxWidth = 600;
					let calculatedHeight = (videoHeight * maxWidth) / videoWidth;
					$videoDiv.css({ width: maxWidth + 'px', height: calculatedHeight + 'px' });
					$popup.css('width', maxWidth + 'px');
				}
			} catch (error) { }
			this.currentVideo.user.videoTrack?.play(this.currentVideo.user.uid.toString());
		} catch (error) { }
	}

	clipText(text: String, length: number) {
		return text.slice(0, length);
	}

	minimizeMain() {
		$("#highlightedVideoPopup").addClass("hide-video-call");
		this.currentVideo = null;
		this.refreshRemoteVideos();
		/* for (let i = 0; i < this.remoteCalls.length; i++) {
			setTimeout(() => {
				this.remoteCalls[i].user.audioTrack?.play();
			}, 1000);
			setTimeout(() => {
				this.remoteCalls[i].user.videoTrack?.play(this.remoteCalls[i].user.uid.toString());
			}, 1000);
		} */
	}

	showDiv(uid: any) {
		try {
			if (uid == this.currentVideo.user.uid) {
				return false;
			} else {
				return true;
			}
		} catch (error) {
			return true;
		}
	}

	startRinging() {
		if (!this.playRingSound.playing()) {
			this.playRingSound.play();
		}
	}

	stopRinging() {
		if (this.playRingSound.playing()) {
			this.playRingSound.stop();
		}
	}

	validURL(str: any) {
		if (!str) {
			return false;
		}
		var pattern = new RegExp('^(https?:\\/\\/)?' +
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
			'((\\d{1,3}\\.){3}\\d{1,3}))' +
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
			'(\\?[;&a-z\\d%_.~+=-]*)?' +
			'(\\#[-a-z\\d_]*)?$', 'i');
		return !!pattern.test(str);
	}

	candidateAndChatFiles: any[] = [];
	fetchingCandFiles = false;
	getFilesFromCandidate() {
		this.fetchingCandFiles = true;
		this.apiService.getCaseFilesFromCandidate(this.caseDetails.id).subscribe({
			next: (data: any) => {
				this.fetchingCandFiles = false;
				this.candidateAndChatFiles = data;
				/* this.candidateAndChatFiles = [
					{
						fileType: "Chat Files",
						files: data.filter((item: any) => item.is_chat)
					},
					{
						fileType: "Files From Candidate",
						files: data.filter((item: any) => !item.is_chat)
					}
				]; */
			}, error: (error) => {
				this.fetchingCandFiles = false;
				this.candidateAndChatFiles = [];
				this.toastr.error("Something went wrong.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	callRecordings: any[] = [];
	fetchingRecordings = false;
	getRecordings() {
		this.fetchingRecordings = true;
		this.apiService.getCallRecordings(this.caseDetails.id).subscribe({
			next: (data: any) => {
				this.fetchingRecordings = false;
				this.callRecordings = data;
			}, error: (error) => {
				this.fetchingRecordings = false;
				this.callRecordings = [];
				this.toastr.error("Something went wrong.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	followupForCandFileSelected(folFileId: any, followupId: any) {
		if (folFileId && followupId) {
			Swal.fire({
				title: 'Please confirm',
				text: 'Are you sure you want to link file(s) with selected follow-up?',
				icon: 'question',
				showCancelButton: true,
				confirmButtonText: 'Yes'
			}).then((result) => {
				if (result.value) {
					let data = {
						id: folFileId,
						followup: followupId
					}
					this.apiService.linkCandidateFiles(data).subscribe({
						next: (data: any) => {
							this.toastr.success('Linked successfully', 'Success', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
							this.getFilesFromCandidate();
							this.apiService.sendFollowUpFilesRefreshEvent();
						}, error: (error) => {
							this.toastr.error('Something went wrong', 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						},
					});
				}
			})
		}
	}

	removeCandidateFile(folFileId: any) {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.apiService.deleteFollowUpFiles({ id: btoa(folFileId) }).subscribe({
					next: data => {
						Swal.fire('Success', 'Record Deleted Successfully.', 'success');
						this.getFilesFromCandidate();
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	selectFiles(type: string) {
		const selectedAtt = this.candidateAndChatFiles.filter((att: any) => att.selected);
		if (!selectedAtt.length) {
			this.toastr.error('No attachment is selected', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let files: any[] = [];
		for (let i = 0; i < selectedAtt.length; i++) {
			if (selectedAtt[i].file_url && selectedAtt[i].file_url.length) {
				for (let j = 0; j < selectedAtt[i].file_url.length; j++) {
					/* There will be only one entry as per implementation but still added for loop in case of future changes */
					const f_name = this.getFileName(selectedAtt[i].file_url[j]);
					files.push({
						"orig_name": f_name,
						"file_name": f_name,
						"url": this.File_Storage_URL + selectedAtt[i].file_url[j],
						"selected": selectedAtt[i].selected
					})
				}
			}
		}
		this.apiService.setAttachmentData({ mailId: null, attachments: files, type: type });
		const type_msg = type == "bill" ? "billing" : "files";
		this.toastr.success('Files selected for ' + type_msg, 'Files selected', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}

	adminNotes: any[] = [];
	fetchingAdminNotes = false;
	adminNotesForm: FormGroup = this.formBuilder.group({
		id: [null],
		notes: [null, [Validators.required]]
	});
	submitAdminNotesLoader = false;
	deleteLoaderAdminNote: any = null;
	formSubmitted1 = false;

	get f1() { return this.adminNotesForm.controls }
	showError1(field: string) {
		if (this.f1[field].invalid && (this.formSubmitted1 || this.f1[field].touched || this.f1[field].dirty)) {
			return true;
		}
		return false;
	}

	getAdminNotes() {
		this.fetchingAdminNotes = true;
		this.apiService.getAdminNotes(this.caseDetails.id).subscribe({
			next: (data: any) => {
				/* for (let i = 0; i < data.data.length; i++) {
					data.data[i].notesWithoutImages = data.data[i].notes.replace(/<img[^>]*>/gi, '');
				} */
				this.fetchingAdminNotes = false;
				this.adminNotes = data.data;
			}, error: (error) => {
				this.fetchingAdminNotes = false;
				this.adminNotes = [];
				this.toastr.error("Something went wrong.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	submitAdminNotes() {
		this.formSubmitted1 = false;
		if (this.adminNotesForm.invalid) {
			this.toastr.info("Please check required fields.", 'Required fields', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			});
			return;
		}
		const payload = this.adminNotesForm.value;
		payload["case_id"] = this.caseDetails.id;
		this.submitAdminNotesLoader = true;
		this.apiService.createUpdateAdminNotes(payload).subscribe({
			next: (data: any) => {
				this.submitAdminNotesLoader = false;
				this.getAdminNotes();
				this.toastr.success("Saved successfully.", 'Success', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
				this.closeAdminNotesModal();
			}, error: (error) => {
				this.submitAdminNotesLoader = false;
				this.toastr.error("Something went wrong.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	openAdminNotesModal(data: any = null) {
		this.formSubmitted1 = false;
		this.setAdminNotesForm(data);
		$("#adminNotesModal").modal("show");
	}

	closeAdminNotesModal() {
		this.setAdminNotesForm();
		$("#adminNotesModal").modal("hide");
	}

	setAdminNotesForm(data: any = {}) {
		this.adminNotesForm.setValue({
			id: data?.id || null,
			notes: data?.notes || null
		});
		this.adminNotesForm.updateValueAndValidity();
	}

	deleteAdminNotes(uId: any) {
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Delete',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.deleteLoaderAdminNote = uId;
				this.apiService.deletAdminNotes(uId).subscribe({
					next: () => {
						this.deleteLoaderAdminNote = null;
						Swal.fire('Success', 'Deleted successfully.', 'success');
						this.getAdminNotes();
					}, error: (error) => {
						this.deleteLoaderAdminNote = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}
}
